/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { SweetAlertIcon } from "sweetalert2";
import Toast from "../../../Widgets/Toast";
import utc from "dayjs/plugin/utc";
import { trackEvent } from "../../../../analytics/analytics";
dayjs.extend(utc);
export const errorMessages = {
	default: "Something went wrong",
};

export const dispositionTypes = {
	citation: "Citation",
	disciplinaryComplaint: "Disciplinary Complaint",
	investigation: "Investigation",
	report: "Report",
	review: "Review",
	case: "Case",
};
export const icons = {
	email: {
		icon: "fas fa-envelope",
		color: "#007BFF",
		fontSize: "18px",
		tooltip: "New Message",
	},
	invoice: {
		icon: "fa fa-dollar-sign",
		color: "#FFC107",
		fontSize: "18px",
		tooltip: "Invoice Activity",
	},
	timer: {
		icon: "fas fa-clock",
		color: "#DC3545",
		fontSize: "18px",
		tooltip: "Timer Alert",
	},
	citationreviewduedate: {
		icon: "fas fa-calendar-day",
		color: "#FD7E14",
		fontSize: "18px",
		tooltip: "Citation Review Due Date",
	},
};

export enum QueryParameterOperation {
	Equal,
	GreaterThan,
	GreaterThanOrEqual,
	LessThan,
	LessThanOrEqual,
	Between,
	NotEqual,
	NotEmpty,
	Like,
	HasAny,
	Contains,
	StartsWith,
	NotLike,
	ContainsAny,
}
export const filterComplianceUsers = (users: IAppUser[]) => {
	let filteredResults;
	filteredResults = users.filter((r) => r.department?.toLowerCase() === "compliance");
	if (filteredResults.length) {
		users = filteredResults;
	}
	// Sort list by last part of displayName ascending
	if (users.length) {
		users = users.sort((a, b) => {
			const lastNameA = a.displayName.split(" ").pop()!.toLowerCase();
			const lastNameB = b.displayName.split(" ").pop()!.toLowerCase();
			return lastNameA > lastNameB ? 1 : lastNameA < lastNameB ? -1 : 0;
		});
	}

	return users.filter((r: IAppUser) => r.department?.toLowerCase() === "compliance");
};
export const sortLegalOutline = (items: any[]) => {
	return items?.sort((a, b) => {
		const aParts = a.ruleNumber.split(".");
		const bParts = b.ruleNumber.split(".");
		const aPartsLength = aParts.length;
		const bPartsLength = bParts.length;
		const minLength = Math.min(aPartsLength, bPartsLength);
		for (let i = 0; i < minLength; i++) {
			const aPart = aParts[i];
			const bPart = bParts[i];
			if (aPart !== bPart) {
				const aPartInt = parseInt(aPart);
				const bPartInt = parseInt(bPart);
				if (aPartInt === bPartInt) {
					return aPart.localeCompare(bPart);
				} else {
					return aPartInt - bPartInt;
				}
			}
		}
		return aPartsLength - bPartsLength;
	});
};

export const getFine = (rule: MLSRuleEntityProperties, listing: IListing | undefined) => {
	if (rule.fineType === "fixed") {
		return rule.citationFee;
	} else if (listing && !listing.error) {
		return listing.listPrice * (rule.citationFee / 100);
	} else {
		return 0;
	}
};

export const showToast = (message: string, type: SweetAlertIcon = "success") => {
	if (message != "Success") {
		trackEvent(`Toast ${type}`, { message: message, url: window.location.href });
	}
	Toast.fire({
		icon: type,
		title: message,
	});
};

export const showSuccessToast = (message: string, type: SweetAlertIcon = "success") => {
	trackEvent(`Toast ${type}`, { message: message, url: window.location.href });

	Toast.fire({
		icon: type,
		title: message,
	});
};

export const showErrorToast = (message: string = "Something went wrong", type: SweetAlertIcon = "error") => {
	trackEvent(`Toast ${type}`, { message: message, url: window.location.href });
	Toast.fire({
		icon: type,
		title: message,
	});
};

export const moneyFormat = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	maximumFractionDigits: 0, // rounds up
});

export const dateFormat = "MM/DD/YYYY";

export const shortDate = (value: string) => {
	if (!value) {
		return "Unknown";
	}
	return dayjs(value).local().format("MM/DD/YYYY");
};
export const shortDateTime = (value: string) => {
	return dayjs(value).local().format("h:mm A MM/DD/YYYY");
};

// unassignedDefault
export const unassignedCaseDefault = "00000000-0000-0000-0000-000000000000";
export const admin = "ADMIN";
// Move
export type RouteParam = {
	caseId: string;
	itemId: string;
	tab: string;
	listingId: string;
	id: string;
};

export interface Pokedex {
	openapi: string;
	info: Info;
	paths: CompliancePaths;
	components: Components;
}

export interface Components {
	schemas: Schemas;
	securitySchemes: SecuritySchemes;
}

export interface Schemas {
	QueryParameterOperation: QueryTion;
	ApiQueryParameter: APIQueryParameter;
	QuerySortDirection: QueryTion;
	ApiSortParameter: APISortParameter;
	ApiQuery: APIQuery;
	ComplianceCaseEntity: ComplianceCaseEntity;
	AlertEntity: AlertEntityClass;
	AlertQueryResult: QueryResult;
	AlertServiceResult: ServiceResult;
	AppealEntity: AppealEntity;
	AppealQueryResult: QueryResult;
	AppealServiceResult: ServiceResult;
	AttachmentEntity: AttachmentEntity;
	AttachmentQueryResult: QueryResult;
	AttachmentServiceResult: ServiceResult;
	MLSRuleEntity: MLSRuleEntity;
	NoticeDefinitionEntity: NoticeDefinitionEntity;
	BillingEntity: BillingEntity;
	BillingQueryResult: QueryResult;
	BillingServiceResult: ServiceResult;
	CaseNoteEntity: AlertEntityClass;
	CaseNoteQueryResult: QueryResult;
	CaseNoteServiceResult: ServiceResult;
	CitationsReviewEntity: CitationsReviewEntity;
	CitationsReviewQueryResult: QueryResult;
	CitationsReviewServiceResult: ServiceResult;
	ComplianceCaseQueryResult: QueryResult;
	ComplianceCaseServiceResult: ServiceResult;
	EnumerationLookupEntity: EnumerationLookupEntity;
	EnumerationLookupQueryResult: QueryResult;
	EnumerationLookupServiceResult: ServiceResult;
	HearingLocationEntity: HearingLocationEntity;
	HearingLocationQueryResult: QueryResult;
	HearingLocationServiceResult: ServiceResult;
	MLSRuleQueryResult: QueryResult;
	MLSRuleServiceResult: ServiceResult;
	NoticeDefinitionQueryResult: QueryResult;
	NoticeDefinitionServiceResult: ServiceResult;
	NotificationEntity: NotificationEntityClass;
	NotificationQueryResult: QueryResult;
	NotificationServiceResult: ServiceResult;
	PaymentEntity: PaymentEntity;
	PaymentQueryResult: QueryResult;
	PaymentServiceResult: ServiceResult;
	ReminderEntity: NotificationEntityClass;
	ReminderQueryResult: QueryResult;
	ReminderServiceResult: ServiceResult;
	ReportReasonCategoryEntity: ReportReasonYEntity;
	ReportReasonPriorityEntity: ReportReasonYEntity;
	ReportReasonEntity: ReportReasonEntity;
	ReportEntity: ReportEntity;
	ReportQueryResult: QueryResult;
	ReportServiceResult: ServiceResult;
	ReportReasonQueryResult: QueryResult;
	ReportReasonServiceResult: ServiceResult;
	ReportReasonCategoryQueryResult: QueryResult;
	ReportReasonCategoryServiceResult: ServiceResult;
	ReportReasonPriorityQueryResult: QueryResult;
	ReportReasonPriorityServiceResult: ServiceResult;
	ReportViolationEntity: ReportViolationEntity;
	ReportViolationQueryResult: QueryResult;
	ReportViolationServiceResult: ServiceResult;
	ViolationEntity: ViolationEntity;
	ViolationQueryResult: QueryResult;
	ViolationServiceResult: ServiceResult;
}

export interface AlertEntityClass {
	required: string[];
	type: AlertEntityType;
	properties: AlertEntityProperties;
	additionalProperties: boolean;
}
// Move
export interface IAppUser {
	indexedOn: string;
	firstName: string;
	lastName: string;
	email: string;
	displayName: string;
	userType: string;
	department: string;
	campaigns: string;
	createdOn: string;
	id: string;
	modifiedOn: string;
}
// Move
export interface AlertEntityProperties {
	complianceCaseId: string;
	complianceCase: string;
	userId?: string;
	text: string;
	clearedOn?: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	contextId?: string;
	noteContext?: string;
	memberName: string;
}

export interface ClearedOn {
	type: ClearedOnType;
	format: Format;
}

export enum ReportStatuses {
	Open = "ReportStatuses.Open",
	Closed = "ReportStatuses.Closed",
}

export enum HistoryEventNames {
	CaseNoteUpdated = "Case Note Updated",
	CaseNotes = "Case Notes",
	Case = "Case",
	CaseReviewStatusChange = "Case Review Status Change",
	CaseAssigned = "Case Assigned",
	CaseDispositionChange = "Case Disposition Change",
	CaseStatusChange = "Case Status Changes",
	InvoiceCreated = "Invoice Created",
	AdminFeeAdded = "Admin Fee Added",
	NoticeDefinition = "NoticeDefinition",
	CitationNotice = "Citation Notice",
	EmailNotice = "Email Notice",
	InquiryNotice = "Inquiry Notice",
	NoticeTypeIncomingEmail = "NoticeType Incoming Email",
	NoticeTypeOther = "NoticeType Other",
	NoticeTypeTranscript = "NoticeType Transcript",
	RevisedCitationNotice = "Revised Citation Notice",
	RevisedInquiryNotice = "Revised Inquiry Notice",
	RevisedWarningNotice = "Revised Warning Notice",
	WarningNotice = "Warning Notice",
	InvoiceCitation = "Invoice Citation",
	PaymentCreated = "Payment Created",
	Report = "Report",
	ReportDispositionChange = "Report Disposition Change",
	ReportAttached = "Report Attached",
	NoticeDefinitions = "NoticeDefinition",
	Invoice = "Invoice",
	CaseInvoice = "Case Invoice",
}

export enum Format {
	DateTime = "date-time",
	Double = "double",
	Int32 = "int32",
	UUID = "uuid",
}

export enum ClearedOnType {
	Integer = "integer",
	Number = "number",
	String = "string",
}

export interface ComplianceCase {
	$ref: string;
}

export interface ContextID {
	type: ClearedOnType;
	nullable: boolean;
}

export interface NoteContext {
	maxLength: number;
	type: ClearedOnType;
	nullable: boolean;
}

export enum AlertEntityType {
	Object = "object",
}

export interface QueryResult {
	type: AlertEntityType;
	properties: AlertQueryResultProperties;
	additionalProperties: boolean;
}

export interface AlertQueryResultProperties {
	pageId: ClearedOn;
	pageSize: ClearedOn;
	totalResults: ClearedOn;
	totalPages: TotalPages;
	isSuccessful: IsSuccessful;
	results: Results;
	exceptions: Exceptions;
	message: Exceptions;
}

export interface Exceptions {
	type: ExceptionsType;
	items?: TicklerAlert;
	nullable: boolean;
	readOnly?: boolean;
}

export interface TicklerAlert {
	type: TicklerAlertType;
}

export enum TicklerAlertType {
	Boolean = "boolean",
	String = "string",
}

export enum ExceptionsType {
	Array = "array",
	String = "string",
}

export interface IsSuccessful {
	type: TicklerAlertType;
	readOnly: boolean;
}

export interface Results {
	type: ExceptionsType;
	items: ComplianceCase;
	nullable: boolean;
}

export interface TotalPages {
	type: ClearedOnType;
	format: Format;
	readOnly: boolean;
}

export interface ServiceResult {
	type: AlertEntityType;
	properties: AlertServiceResultProperties;
	additionalProperties: boolean;
}

export interface AlertServiceResultProperties {
	isSuccessful: IsSuccessful;
	results: Results;
	exceptions: Exceptions;
	message: Exceptions;
}

export interface APIQuery {
	type: AlertEntityType;
	properties: APIQueryProperties;
	additionalProperties: boolean;
}

export interface APIQueryProperties {
	pageId: ClearedOn;
	pageSize: ClearedOn;
	criteria: Results;
	orderBy: Results;
	fields: Exceptions;
}

export interface APIQueryParameter {
	type: AlertEntityType;
	properties: APIQueryParameterProperties;
	additionalProperties: boolean;
}

export interface APIQueryParameterProperties {
	field: ContextID;
	op: ComplianceCase;
	values: Exceptions;
}

export interface APISortParameter {
	type: AlertEntityType;
	properties: APISortParameterProperties;
	additionalProperties: boolean;
}

export interface APISortParameterProperties {
	field: ContextID;
	direction: ComplianceCase;
}

export interface AppealEntity {
	required: string[];
	type: AlertEntityType;
	properties: AppealEntityProperties;
	additionalProperties: boolean;
}

export interface AppealEntityProperties {
	hearingDate: ClearedOn;
	locationName: NoteContext;
	staffRemarks: ContextID;
	requestedOn: ClearedOn;
	complianceCaseId: ClearedOn;
	complianceCase: ComplianceCase;
	outcome: NoteContext;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
}

export interface AttachmentEntity {
	required: string[];
	type: AlertEntityType;
	properties: AttachmentEntityProperties;
	additionalProperties: boolean;
}

export interface AttachmentEntityProperties {
	complianceCaseId: ClearedOn;
	complianceCase: ComplianceCase;
	url: ContextID;
	mediaType: NoteContext;
	description: ContextID;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
}

export interface BillingEntity {
	required: string[];
	type: AlertEntityType;
	properties: BillingEntityProperties;
	additionalProperties: boolean;
}

export interface BillingEntityProperties {
	mlsRuleId: string;
	mlsRule: string;
	suspensionNoticeSentDate: Date;
	newSuspsensionDate: Date;
	graceNoticeSent: Date;
	refundDate: Date;
	invoiceStatus: string;
	invoiceLink: string;
	refundAmount: string;
	noticeDefinitionId: string;
	noticeDefinition: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
}

export interface CitationsReviewEntity {
	required: string[];
	type: AlertEntityType;
	properties: CitationsReviewEntityProperties;
	additionalProperties: boolean;
}

export interface CitationsReviewEntityProperties {
	requestReceived: Date;
	packedCreatedBy: string;
	hearingRequested: Date;
	packetSentToAor: Date;
	violationRequested: Date;
	citationReviewStatus: string;
	invoiceVoided: Date;
	dateRecievedByAor: Date;
	ratificationDate: Date;
	grievanceCommitteeReview: Date;
	revisedPaymentAmount: string;
	tempHearingDate: Date;
	newDueDate: Date;
	noticeDefinitionId: string;
	noticeDefinition: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
}

export interface ComplianceCaseEntity {
	required: string[];
	type: AlertEntityType;
	properties: ComplianceCaseEntityProperties;
	additionalProperties: boolean;
}

export enum CaseStatus {
	Open = "Open",
	Pending = "Pending",
	Closed = "Closed",
	Unassigned = "Unassigned",
	Assigned = "Assigned",
}
// move
export interface ComplianceCaseEntityProperties {
	memberName: string;
	rulesIds?: string[];
	rules: MLSRuleEntityProperties[];
	caseNumber: string;
	memberStatus: string;
	memberAor: string;
	unseenChanges: boolean;
	ticklerAlert: boolean;
	violations: ViolationEntityProperties[];
	tickler: string;
	reason: string;
	ruleId?: string;
	ruleTitle?: string;
	description?: string;
	priority: string | null;
	memberId: string;
	assignTo: string;
	assignName: string | null;
	referenceNumber: string | null;
	firstNotifiedOn: string;
	closedOn: string;
	caseObject: string | null;
	disposition: string | null;
	status: CaseStatus;
	listingId: string | null;
	createdBy: string | null;
	createdOn: string;
	id: string;
	modifiedBy?: string;
	modifiedOn?: string;
	new?: boolean;
	reportIds?: string[];
}

export interface EnumerationLookupEntity {
	required: string[];
	type: AlertEntityType;
	properties: EnumerationLookupEntityProperties;
	additionalProperties: boolean;
}

export interface EnumerationLookupEntityProperties {
	enumerationName: string;
	name: string;
	value: string;
	displayName: string;
	description: string;
	displayOrder: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
}

export interface EnumerationName {
	maxLength: number;
	type: ClearedOnType;
}

export interface HearingLocationEntity {
	type: AlertEntityType;
	properties: HearingLocationEntityProperties;
	additionalProperties: boolean;
}

export interface HearingLocationEntityProperties {
	name: NoteContext;
	displayName: NoteContext;
	description: NoteContext;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
}

// Move
export interface IResponse<Type> {
	results: Type[];
}

export interface MLSRuleEntity {
	required: string[];
	type: AlertEntityType;
	properties: MLSRuleEntityProperties;
	additionalProperties: boolean;
}
// Move

export interface MLSRuleEntityProperties {
	ruleNumber: string;
	ruleTitle: string;
	warning: boolean;
	fineType: "fixed" | "percentage";
	citationFee: number;
	mlsRulebookText: string;
	processingGuideline: string;
	emailTemplate: string;
	citationTemplate: string;
	inquiryTemplate: string;
	warningTemplate: string;
	resources: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
}

export interface NoticeDefinitionEntity {
	required: string[];
	type: AlertEntityType;
	properties: NoticeDefinitionEntityProperties;
	additionalProperties: boolean;
}
export enum NoticeType {
	All = "NoticeType.All",
	Email = "NoticeType.Email",
	OffSystemEmail = "NoticeType.OffSystemEmail",
	Complaint = "NoticeType.Complaint",
	Inquiry = "NoticeType.Inquiry",
	Warning = "NoticeType.Warning",
	Citation = "NoticeType.Citation",
	Chat = "NoticeType.Chat",
	Call = "NoticeType.Call",
	Transcript = "NoticeType.Transcript",
	IncomingEmail = "NoticeType.Incoming Email",
	Other = "NoticeType.Other",
}
export const noticesWithTemplates = [NoticeType.Citation, NoticeType.Inquiry, NoticeType.Warning, NoticeType.Email].map((notice) => notice.replace("NoticeType.", ""));

// chatLog: [
// 	{
// 		date: "2023-04-29T17:57:06.053+00:00",
// 		user: "Admin",
// 		sender: "Jane Smith",
// 		text: "Hi John, I am your compliance analyst and I'll be handling your case today.",
// 	},
export interface Chatlog {
	date: string;
	user: "analyst" | "agent";
	sender: string;
	text: string;
}

export interface NoticeReply {
	noticeDefinitionId: string;
	isRead: boolean;
	body: string;
	senderName: string;
	senderId: string;
	subject: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	includeMember: boolean;
	toEmails: string;
	bccEmails: string;
	ccEmails: string;
	ccAor: boolean;
	ccOfice: boolean;
	friendlySenderName: string;
	fromEmail?: string;
}
export interface NoteHeadlineEntityProperties {
	name: string;
	id: string;
	isTask: boolean;
}
export interface NoticeDefinitionEntityProperties {
	//unreadActivity?: boolean;
	replies: NoticeReply[];
	name: string;
	displayName: string;
	//todo maher ensure this works
	call?: {
		url: string;
		agent: string;
		analyst: string;
	};
	chatLog?: Chatlog[];
	corrected?: boolean;
	description: string;
	createdByName: string;
	templateName: string;
	issuedFailureToCorrect: boolean;
	expiresOn: string;
	policyReference: string;
	fineAmount: string;
	actionClassName: string;
	noticeType: string;
	status: string;
	activeOn: string;
	reportViolationId: string;
	statement: string;
	correctiveAction: string;
	correctiveActionDeadline: string;
	analystNote: string;
	complianceCaseId: string;
	complianceCase: ComplianceCaseEntityProperties;
	reviewDeadline: string;
	suspensionDate: string;
	combineWith: string;
	ccEmails: string;
	ccAor: string;
	ccOfice: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	rule?: MLSRuleEntityProperties;
	ruleId?: string;
	violations: ViolationEntityProperties[];
	violationIds: string[];
	userSuspended?: boolean;
	includeMember?: boolean;
	to: string;
	subject: string;
	emailRequestMessageId: string;
	attachments?: string[];
	revision?: boolean;
	revisionHistory?: string[];
	toEmails?: string;
	bccEmails?: string;
	objectData?: any;
	objectDataModel?: { email: { member: INoticeEmailData; office: INoticeEmailData; aor: INoticeEmailData } };
}
export interface INoticeEmailData {
	name: string;
	email: string;
}

// move
export enum CorrectionStatus {
	NotCorrected = "CorrectionStatus.NotCorrected",
	Corrected = "CorrectionStatus.Corrected",
}
//

// Move

export interface ReviewDeadline {
	type: ClearedOnType;
	format: Format;
	nullable: boolean;
}

export interface NotificationEntityClass {
	required: string[];
	type: AlertEntityType;
	properties: NotificationEntityProperties;
	additionalProperties: boolean;
}

export interface NotificationEntityProperties {
	complianceCaseId: ClearedOn;
	complianceCase: ComplianceCase;
	messageId?: ClearedOn;
	notificationType?: NoteContext;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
	text?: NoteContext;
	alertOn?: ClearedOn;
}

export interface PaymentEntity {
	required: string[];
	type: AlertEntityType;
	properties: PaymentEntityProperties;
	additionalProperties: boolean;
}

export interface PaymentEntityProperties {
	adminFee: ClearedOn;
	paymentType: NoteContext;
	paymentDate: ClearedOn;
	payMethod: NoteContext;
	billingId: ClearedOn;
	billing: ComplianceCase;
	totaPayment: ClearedOn;
	paymentPaid: ContextID;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
}

export interface QueryTion {
	enum: number[];
	type: ClearedOnType;
	format: Format;
}

export interface ReportEntity {
	required: string[];
	type: AlertEntityType;
	properties: ReportEntityProperties;
	additionalProperties: boolean;
}
// Move
export interface ReportEntityProperties {
	confirmationEmailSentAt: string;
	confirmationEmailSentTo: string;
	memberAor: string;
	reason?: ReportReasonEntityProperties;
	office: string;
	reportedOn: string;
	reportedBy: string;
	dispositionDetails?: EnumerationLookupEntityProperties;
	memberId: string;
	referenceId: string;
	referenceNumber: string;
	text: string;
	disposition: string;
	reportSource: string;
	reportType: string;
	listingId: string;
	reportReasonId: string;
	reportReason: ReportReasonEntityProperties;
	referenceType: string;
	reportedByName: string;
	closedBy: string;
	closedDate: string;
	status: string;
	isOpen: boolean;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	memberName: string;
	violationCount: number;
	createdByName: string;
	dueDate: string;
	reportNumber: string;
	enumerationLookupId: string;
	reportingParty: string;
	objectData: string;
}

export interface ReportReasonYEntity {
	required: string[];
	type: AlertEntityType;
	properties: ReportReasonCategoryEntityProperties;
	additionalProperties: boolean;
}

export interface ReportReasonCategoryEntityProperties {
	displayText: EnumerationName;
	description: EnumerationName;
	value: EnumerationName;
	createdBy: ContextID;
	createdOn: ClearedOn;
	id: ClearedOn;
	modifiedBy: ContextID;
	modifiedOn: ClearedOn;
}

export interface ReportReasonEntity {
	required: string[];
	type: AlertEntityType;
	properties: ReportReasonEntityProperties;
	additionalProperties: boolean;
}

export interface ReportReasonEntityProperties {
	reasonText: string;
	reportReasonCategoryId: number | string;
	reportReasonCategory: ReportReasonCategoryEntityProperties;
	mlsRuleId: string;
	mlsRule: MLSRuleEntityProperties;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	daysUntilDue: number;
}

export interface ReportViolationEntity {
	required: string[];
	type: AlertEntityType;
	properties: ReportViolationEntityProperties;
	additionalProperties: boolean;
}

// Move
export interface ReportViolationEntityPropertiesWithRule extends ReportViolationEntityProperties {
	attachedRule: MLSRuleEntityProperties | undefined;
	attachedDisposition?: EnumerationLookupEntityProperties | undefined;
}

//Move
export interface ReportViolationEntityProperties {
	reportId: string;
	reportIds: string[];
	report: string;
	mlsRuleId: string;
	mlsRule: string;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	note: string;
	dispositionId: string;
	dispositionNote: string;
}

export interface ViolationEntity {
	required: string[];
	type: AlertEntityType;
	properties: ViolationEntityProperties;
	additionalProperties: boolean;
}

export interface ViolationEntityProperties {
	complianceCaseId: string;
	mlsRule: MLSRuleEntityProperties;
	enumerationLookupId: string;
	correctionStatusLookupId: string;
	enumerationLookup?: EnumerationLookupEntityProperties;
	mlsRuleId: string;
	id: string;
	createdOn: string;
	corrected: string;
	reportId?: string;
	report?: ReportEntityProperties;
}

export interface SecuritySchemes {
	oauth2: Oauth2;
}

export interface Oauth2 {
	type: string;
	flows: Flows;
}

export interface Flows {
	implicit: Implicit;
}

export interface Implicit {
	authorizationUrl: string;
	tokenUrl: string;
	scopes: Scopes;
}

export interface Scopes {
	"https://macewindu.azurewebsites.net/user_impersonation": string;
}

export interface Info {
	title: string;
	description: string;
	termsOfService: string;
	contact: Contact;
	license: License;
	version: string;
}

export interface Contact {
	name: string;
	url: string;
	email: string;
}

export interface License {
	name: string;
	url: string;
}

export interface CaseNoteEntityProperties {
	headline: NoteHeadlineEntityProperties;
	createdByName: string;
	assignName: string;
	listingId: string;
	memberName: string;
	note: string;
	caseNumber: string;
	link: string;
	complianceCaseId: string;
	complianceCase: string;
	text: string;
	contextId: string;
	noteContext: string;
	reminderDate: string;
	isDeleted: boolean;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
}
export const caseNoteTypes = [
	"Investigative Note",
	"General Task",
	"Chat Note",
	"Email Note",
	"Phone Call Note",
	"Follow up Note",
	"Escalation Note",
	"Escalation Review",
	"Escalation Resolution",
	"Lead Note",
	"Supervisor Note",
	"Manager/Director Note",
	"Document Review Note",
	"Citation Withdraw Note",
	"Combined Citation Note",
	"Original Disposition Note",
	"Billing Note",
	"CRR Note",
	"Voice Mail Note",
	"CRR Form/Invoice Voided",
	"CRR Deadline/Suspension Date",
	"Disciplinary Complaint Note",
];
export interface CompliancePaths {
	"/api/app/Alerts/q": APIAppAlertsQClass;
	"/api/app/Alerts": APIAppAlertsClass;
	"/api/app/Alerts/{id}": APIAppID;
	"/api/app/Appeals/q": APIAppAlertsQClass;
	"/api/app/Appeals": APIAppAlertsClass;
	"/api/app/Appeals/{id}": APIAppID;
	"/api/app/Attachments/q": APIAppAlertsQClass;
	"/api/app/Attachments": APIAppAlertsClass;
	"/api/app/Attachments/{id}": APIAppID;
	"/api/app/Billings/q": APIAppAlertsQClass;
	"/api/app/Billings": APIAppAlertsClass;
	"/api/app/Billings/{id}": APIAppID;
	"/api/app/CaseNotes/q": APIAppAlertsQClass;
	"/api/app/CaseNotes": APIAppAlertsClass;
	"/api/app/CaseNotes/{id}": APIAppID;
	"/api/app/CitationsReview/q": APIAppAlertsQClass;
	"/api/app/CitationsReview": APIAppAlertsClass;
	"/api/app/CitationsReview/{id}": APIAppID;
	"/api/app/ComplianceCases/q": APIAppAlertsQClass;
	"/api/app/ComplianceCases": APIAppAlertsClass;
	"/api/app/ComplianceCases/{id}": APIAppID;
	"/api/app/EnumerationLookups/q": APIAppAlertsQClass;
	"/api/app/EnumerationLookups": APIAppAlertsClass;
	"/api/app/EnumerationLookups/{id}": APIAppEnumerationLookupsID;
	"/api/app/HearingLocations/q": APIAppAlertsQClass;
	"/api/app/HearingLocations": APIAppAlertsClass;
	"/api/app/HearingLocations/{id}": APIAppID;
	"/api/app/MLSRules/q": APIAppAlertsQClass;
	"/api/app/MLSRules": APIAppAlertsClass;
	"/api/app/MLSRules/{id}": APIAppSID;
	"/api/app/NoticeDefinitions/CitationCount/{id}": APIAppNoticeDefinitionsCitationCountID;
	"/api/app/NoticeDefinitions/q": APIAppAlertsQClass;
	"/api/app/NoticeDefinitions": APIAppAlertsClass;
	"/api/app/NoticeDefinitions/{id}": APIAppID;
	"/api/app/Notifications/q": APIAppAlertsQClass;
	"/api/app/Notifications": APIAppAlertsClass;
	"/api/app/Notifications/{id}": APIAppID;
	"/api/app/Payments/q": APIAppAlertsQClass;
	"/api/app/Payments": APIAppAlertsClass;
	"/api/app/Payments/{id}": APIAppID;
	"/api/app/Reminders/q": APIAppAlertsQClass;
	"/api/app/Reminders": APIAppAlertsClass;
	"/api/app/Reminders/{id}": APIAppID;
	"/api/app/Reports/GetByComplianceCase/{id}": APIAppReportsGetByComplianceCaseID;
	"/api/app/Reports/q": APIAppAlertsQClass;
	"/api/app/Reports": APIAppAlertsClass;
	"/api/app/Reports/{id}": APIAppID;
	"/api/app/ReportReasons/q": APIAppAlertsQClass;
	"/api/app/ReportReasons": APIAppAlertsClass;
	"/api/app/ReportReasons/{id}": APIAppSID;
	"/api/app/ReportReasonCategories/q": APIAppAlertsQClass;
	"/api/app/ReportReasonCategories": APIAppAlertsClass;
	"/api/app/ReportReasonCategories/{id}": APIAppSID;
	"/api/app/ReportReasonPriorities/q": APIAppAlertsQClass;
	"/api/app/ReportReasonPriorities": APIAppAlertsClass;
	"/api/app/ReportReasonPriorities/{id}": APIAppSID;
	"/api/app/ReportViolations/q": APIAppAlertsQClass;
	"/api/app/ReportViolations": APIAppAlertsClass;
	"/api/app/ReportViolations/{id}": APIAppID;
	"/api/app/Violations/q": APIAppAlertsQClass;
	"/api/app/Violations": APIAppAlertsClass;
	"/api/app/Violations/{id}": APIAppID;
}

export interface APIAppAlertsClass {
	post: APIAppAlertsPost;
}

export interface APIAppAlertsPost {
	tags: string[];
	summary: string;
	description: string;
	requestBody: GetRequestBody;
	responses: { [key: string]: PostResponse };
	security: Security[];
}

export interface GetRequestBody {
	description: string;
	content: RequestBodyContent;
}

export interface RequestBodyContent {
	"application/json-patch+json": JSON;
	"application/json": JSON;
	"text/json": JSON;
	"application/*+json": JSON;
}

export interface JSON {
	schema: ComplianceCase;
}

export interface PostResponse {
	description: string;
	content?: PurpleContent;
}

export interface PurpleContent {
	"application/json": JSON;
}

export interface Security {
	oauth2: any[];
}

export interface APIAppAlertsQClass {
	post: APIAppAlertsQPost;
}

export interface APIAppAlertsQPost {
	tags: string[];
	summary: string;
	parameters: PostParameter[];
	requestBody: PurpleRequestBody;
	responses: { [key: string]: PostResponse };
	security: Security[];
}

export interface PostParameter {
	name: PurpleName;
	in: PurpleIn;
	schema: ContextID;
}

export enum PurpleIn {
	Query = "query",
}

export enum PurpleName {
	F = "f",
}

export interface PurpleRequestBody {
	content: RequestBodyContent;
}

export interface APIAppID {
	get: PutClass;
	put: Put;
}

export interface PutClass {
	tags: string[];
	summary: string;
	parameters: PurpleParameter[];
	responses: { [key: string]: PostResponse };
	security: Security[];
	requestBody?: GetRequestBody;
}

export interface PurpleParameter {
	name: FluffyName;
	in: FluffyIn;
	description: string;
	required: boolean;
	schema: PurpleSchema;
}

export enum FluffyIn {
	Path = "path",
}

export enum FluffyName {
	ID = "id",
}

export interface PurpleSchema {
	type: ClearedOnType;
	description: string;
	nullable: boolean;
}

export interface Put {
	tags: string[];
	summary: string;
	parameters: DeleteParameter[];
	requestBody?: GetRequestBody;
	responses: { [key: string]: PostResponse };
	security: Security[];
}

export interface DeleteParameter {
	name: FluffyName;
	in: FluffyIn;
	description: Description;
	required: boolean;
	schema: FluffySchema;
}

export enum Description {
	ComplianceCaseID = "Compliance Case ID",
	Empty = "",
}

export interface FluffySchema {
	type: ClearedOnType;
	description: Description;
	format: Format;
}

export interface APIAppEnumerationLookupsID {
	get: PutClass;
	put: PutClass;
}

export interface APIAppSID {
	get: PutClass;
	put: Put;
	delete: Put;
}

export interface APIAppNoticeDefinitionsCitationCountID {
	get: APIAppNoticeDefinitionsCitationCountIDGet;
}

export interface APIAppNoticeDefinitionsCitationCountIDGet {
	tags: string[];
	summary: string;
	parameters: DeleteParameter[];
	responses: { [key: string]: PurpleResponse };
	security: Security[];
}

export interface PurpleResponse {
	description: string;
	content?: FluffyContent;
}

export interface FluffyContent {
	"application/json": ApplicationJSON;
}

export interface ApplicationJSON {
	schema: ClearedOn;
}

export interface APIAppReportsGetByComplianceCaseID {
	get: Put;
}

interface MediaItem {
	mediaKey: string;
	originatingSystemMediaKey: number;
	resourceRecordKeyNumeric: number;
	originatingSystemResourceRecordKey: number;
	longDescription: string;
	mediaURL: string;
	originatingSystemMediaURL: string;
	order: number;
	mediaObjectID: string;
	resourceName: string;
	className: number;
	mediaType: string;
	mediaType_Long: string;
	mediaCategory: string;
	fileExtension: string;
	fileTable: string;
	modificationTimestamp: string;
	mediaModificationTimestamp: string;
	deletedYN: boolean;
	originatingSystemID_Long: string;
	originatingSystemID: string;
	memberAOR: string;
	memberAOR_Long: string;
	officeMlsId: string;
	changedByMemberID: string;
	changedByMemberKeyNumeric: string;
	group: string;
	imageHeight: string;
	imageSizeDescription: string;
	imageWidth: string;
	mediaHTML: string;
	mediaStatus: string;
	permission: string;
	resourceRecordID: string;
	shortDescription: string;
	originalFilename: string;
	imageOf: string;
	approved: string;
	fileSize: string;
	createdBy: string;
	createdOn: string;
	modifiedBy: string;
	modifiedOn: string;
}
export interface DisplinaryComplaintEntityProperties {
	datePacketCreated: Date;
	packetCreatedBy: string;
	violationCorrected: string;
	packetStatus: string;
	dateSentToAor: Date;
	dateReceived: Date;
	dateHearing: Date;
	body: string;
	id: string;
	dispositionId: string;
	sent: boolean;
	caseId: string;
}
export interface CaseReviewEntityProperties {
	requestReceived: Date;
	packedCreatedBy: string;
	hearingRequested: Date;
	packetSentToAor: Date;
	violationRequested: Date;
	status: string;
	invoiceVoided: Date;
	dateRecievedByAor: Date;
	ratificationDate: Date;
	grievanceCommitteeReview: Date;
	revisedPaymentAmount: string;
	tempHearingDate: Date;
	newDueDate: Date;
	complianceCaseId: string;
	complianceCase: ComplianceCaseEntityProperties;
	createdBy: string;
	createdOn: string;
	id: string;
	modifiedBy: string;
	modifiedOn: string;
	caseReviewStatus: string;
	type: string;
	fee: string;
}

export interface IListing {
	error: any;
	media: MediaItem[];
	propertyADU: any[];
	propertyGreen: any[];
	propertyUnit: any[];
	powerProduction: any[];
	member: any[];
	office: any[];
	accessibilityFeatures: string;
	accountingType: string;
	additionalDimensions: string;
	additionalParcelsDescription: string;
	additionalParcelsYN: boolean;
	additionalRentForPets: string;
	adNumber: string;
	advertisingExpense: string;
	amperage: string;
	anchorsCoTenants: string;
	appliances: string;
	appliancesYN: boolean;
	architecturalStyle: string;
	assessments: string;
	assessmentsYN: boolean;
	assetClass: string;
	associationAmenities: string;
	associationFee: number;
	associationFee2: string;
	associationFee2Frequency: string;
	associationFee3: string;
	associationFee3Frequency: string;
	associationFeeFrequency: string;
	associationManagementName: string;
	associationManagementName2: string;
	associationManagementName3: string;
	associationName: string;
	associationName2: string;
	associationName3: string;
	associationPhone: string;
	associationPhone2: string;
	associationPhone2Ext: string;
	associationPhone3: string;
	associationPhoneExt: string;
	associationPhone3Ext: string;
	associationYN: boolean;
	attachedGarageYN: string;
	autoSoldDate: string;
	autoSoldYN: boolean;
	availabilityDate: string;
	average1BedArea: string;
	average1BedAreaUnits: string;
	average2BedArea: string;
	average2BedAreaUnits: string;
	average3BedArea: string;
	average3BedAreaUnits: string;
	averageStudioArea: string;
	averageStudioAreaUnits: string;
	backOnMarketDate: string;
	backupDate: string;
	basement: string;
	bathroomsFull: number;
	bathroomsFullAndThreeQuarter: number;
	bathroomsHalf: string;
	bathroomsOneQuarter: string;
	bathroomsThreeQuarter: string;
	bathroomsTotalInteger: number;
	bedroomsTotal: number;
	belowGradeFinishedArea: string;
	belowGradeFinishedAreaUnits: string;
	bodyType: string;
	builderModel: string;
	builderModelCode: string;
	builderName: string;
	buildingAreaTotal: string;
	buildingAreaUnits: string;
	buildingExpenses: string;
	buildingFeatures: string;
	buildingName: string;
	buildingStatus: string;
	businessName: string;
	businessType: string;
	businessURL: string;
	buyerAgencyCompensation: number;
	buyerAgencyCompensationPer: string;
	buyerAgencyCompensationRemarks: string;
	buyerAgencyCompensationType: string;
	buyerAgentAOR: string;
	buyerAgentBrokerKeyNumeric: string;
	buyerAgentBrokerMlsId: string;
	buyerAgentFirstName: string;
	buyerAgentKeyNumeric: number;
	buyerAgentLastName: string;
	buyerAgentMainOfficeKeyNumeric: string;
	buyerAgentMainOfficeMlsId: string;
	buyerAgentMlsId: string;
	buyerAgentStateLicense: string;
	buyerFinancing: string;
	buyerOfficeAOR: string;
	buyerOfficeKeyNumeric: number;
	buyerOfficeMlsId: string;
	buyerOfficeName: string;
	buyerOfficeStateLicense: string;
	buyerTeamEmail: string;
	buyerTeamKey: string;
	buyerTeamKeyNumeric: string;
	buyerTeamName: string;
	buyerTeamPreferredPhone: string;
	cableTvExpense: string;
	cancellationDate: string;
	capRate: string;
	carportSpaces: number;
	cashiersCheck: string;
	cdomResetYN: string;
	certified433aYN: string;
	city: string;
	clearanceHeightMax: string;
	clearanceHeightMin: string;
	cleared: string;
	closeDate: string;
	closePrice: number;
	coBuyerAgentAOR: string;
	coBuyerAgentBrokerKeyNumeric: string;
	coBuyerAgentBrokerMlsId: string;
	coBuyerAgentFirstName: string;
	coBuyerAgentKeyNumeric: string;
	coBuyerAgentLastName: string;
	coBuyerAgentMainOfficeKeyNumeric: string;
	coBuyerAgentMainOfficeMlsId: string;
	coBuyerAgentMlsId: string;
	coBuyerAgentStateLicense: string;
	coBuyerOfficeAOR: string;
	coBuyerOfficeKeyNumeric: string;
	coBuyerOfficeMlsId: string;
	coBuyerOfficeName: string;
	coBuyerOfficeStateLicense: string;
	coBuyerTeamEmail: string;
	coBuyerTeamKey: string;
	coBuyerTeamKeyNumeric: string;
	coBuyerTeamName: string;
	coBuyerTeamPreferredPhone: string;
	coListAgentAOR: string;
	coListAgentBrokerKeyNumeric: string;
	coListAgentBrokerMlsId: string;
	coListAgentDirectPhone: string;
	coListAgentDirectPhoneExt: string;
	coListAgentEmail: string;
	coListAgentFax: string;
	coListAgentFirstName: string;
	coListAgentHomePhone: string;
	coListAgentHomePhoneExt: string;
	coListAgentKeyNumeric: string;
	coListAgentLanguages: string;
	coListAgentLastName: string;
	coListAgentMainOfficeKeyNumeric: string;
	coListAgentMainOfficeMlsId: string;
	coListAgentMlsId: string;
	coListAgentMobilePhone: string;
	coListAgentPager: string;
	coListAgentStateLicense: string;
	coListAgentTollFreePhone: string;
	coListAgentTollFreePhoneExt: string;
	coListAgentVoiceMail: string;
	coListAgentVoiceMailExt: string;
	coListOfficeAOR: string;
	coListOfficeFax: string;
	coListOfficeKeyNumeric: string;
	coListOfficeMlsId: string;
	coListOfficeName: string;
	coListOfficePhone: string;
	coListOfficePhoneExt: string;
	coListOfficeStateLicense: string;
	coListTeamEmail: string;
	coListTeamKey: string;
	coListTeamKeyNumeric: string;
	coListTeamName: string;
	coListTeamPreferredPhone: string;
	commonInterest: string;
	commonWalls: string;
	communityFeatures: string;
	compListingYN: string;
	concessionsAmount: number;
	concessionsComments: string;
	condoArea: string;
	condoAreaUnits: string;
	constructionMaterials: string;
	contactOrder1: string;
	contactOrder2: string;
	contactOrder3: string;
	contactOrder4: string;
	contactOrder5: string;
	contactOrder6: string;
	contingency: string;
	contingencyEndDate: string;
	contingencyList: string;
	contingentDate: string;
	contractStatusChangeDate: string;
	cooling: string;
	coolingYN: boolean;
	country: string;
	countyOrParish: string;
	creditAmount: string;
	creditCheckPaidBy: string;
	creditCheckYN: string;
	cumulativeDaysOnMarket: number;
	currentCommercialUse: string;
	currentFinancing: string;
	currentGeologicalYN: string;
	currentPrice: number;
	currentUse: string;
	currentUseComments: string;
	dateLeaseExpires: string;
	daysOnMarket: number;
	deletedYN: boolean;
	depositKey: string;
	depositOther: string;
	depositPets: string;
	depositSecurity: string;
	directionFaces: string;
	directions: string;
	disclosures: string;
	distanceToBusComments: string;
	distanceToElectricComments: string;
	distanceToFreewayComments: string;
	distanceToGasComments: string;
	distanceToPhoneServiceComments: string;
	distanceToPlaceofWorshipComments: string;
	distanceToSchoolsComments: string;
	distanceToSewerComments: string;
	distanceToShoppingComments: string;
	distanceToStreetComments: string;
	distanceToWaterComments: string;
	divisibleSQFT: string;
	documentNumber: string;
	documentsChangeTimestamp: string;
	documentsCount: string;
	doH1: string;
	doH2: string;
	doH3: string;
	doorFeatures: string;
	dualVariableCompensationYN: boolean;
	eatingArea: string;
	effectiveGross: string;
	electric: string;
	electricExpense: string;
	elementarySchool: string;
	elementarySchoolOther: string;
	elevation: string;
	elevationUnits: string;
	endingDate: string;
	entryLevel: string;
	entryLocation: string;
	equipmentExpense: string;
	equipmentValue: string;
	estimatedBuyerAgentAOR: string;
	estimatedBuyerAgentFirstName: string;
	estimatedBuyerAgentKeyNumeric: string;
	estimatedBuyerAgentLastName: string;
	estimatedBuyerAgentMlsId: string;
	estimatedBuyerAgentStateLicense: string;
	estimatedBuyerFinancing: string;
	estimatedBuyerOfficeAOR: string;
	estimatedBuyerOfficeKeyNumeric: string;
	estimatedBuyerOfficeMlsId: string;
	estimatedBuyerOfficeName: string;
	estimatedBuyerOfficeStateLicense: string;
	estimatedBuyerTeamEmail: string;
	estimatedBuyerTeamKey: string;
	estimatedBuyerTeamKeyNumeric: string;
	estimatedBuyerTeamName: string;
	estimatedBuyerTeamPreferredPhone: string;
	estimatedCloseDate: string;
	estimatedClosePrice: number;
	estimatedCoBuyerAgentAOR: string;
	estimatedCoBuyerAgentFirstName: string;
	estimatedCoBuyerAgentKeyNumeric: string;
	estimatedCoBuyerAgentLastName: string;
	estimatedCoBuyerAgentMlsId: string;
	estimatedCoBuyerAgentStateLicense: string;
	estimatedCoBuyerOfficeAOR: string;
	estimatedCoBuyerOfficeKeyNumeric: string;
	estimatedCoBuyerOfficeMlsId: string;
	estimatedCoBuyerOfficeName: string;
	estimatedCoBuyerOfficeStateLicense: string;
	estimatedCoBuyerTeamEmail: string;
	estimatedCoBuyerTeamKey: string;
	estimatedCoBuyerTeamKeyNumeric: string;
	estimatedCoBuyerTeamName: string;
	estimatedCoBuyerTeamPreferredPhone: string;
	estimatedConcessionsAmount: string;
	estimatedConcessionsComments: string;
	estimatedContingencyList: string;
	exclusions: string;
	existingLeaseType: string;
	expenseYear: string;
	expirationDate: string;
	exteriorFeatures: string;
	fenceYN: boolean;
	fencing: string;
	fhaEligibility: string;
	financialInfoAsOf: string;
	financialRemarks: string;
	fireplaceFeatures: string;
	fireplaceYN: string;
	firstRepairs: string;
	flooring: string;
	foundationDetails: string;
	fuelExpense: string;
	furnished: string;
	furnitureReplacementExpense: string;
	garageIncome: string;
	garageRentalRate: string;
	garageSpaces: number;
	gardenerExpense: string;
	geocodeModificationTimestamp: string;
	geocodeOverrideYN: string;
	geocodeSource: string;
	greenEnergyEfficient: string;
	greenEnergyGeneration: string;
	greenIndoorAirQuality: string;
	greenLocation: string;
	greenSustainability: string;
	greenWaterConservation: string;
	grossEquity: string;
	grossIncome: string;
	grossMultiplier: string;
	grossOperatingIncome: string;
	grossScheduledIncome: string;
	grossSpendableIncome: string;
	have: string;
	heating: string;
	heatingYN: boolean;
	highSchool: string;
	highSchoolDistrict: string;
	highSchoolOther: string;
	highTechFlexSquareFootage: string;
	holdActivationDate: string;
	holdDate: string;
	hoursDaysOfOperation: string;
	hoursDaysOfOperationDescription: string;
	hoursOwnerWorks: string;
	improvements: string;
	improvementsAmount: string;
	improvementsPercent: string;
	inclusions: string;
	industrialSquareFootage: string;
	industrialSquareFootageMax: string;
	industrialSquareFootageMin: string;
	industrialType: string;
	ingressEgress: string;
	insuranceExpense: string;
	insuranceWaterFurnitureYN: string;
	interiorFeatures: string;
	internetAddressDisplayYN: boolean;
	internetAutomatedValuationDisplayYN: boolean;
	internetConsumerCommentYN: boolean;
	internetEntireListingDisplayYN: boolean;
	internetSendListPriceYN: string;
	inventoryValue: string;
	investmentPropertyYN: string;
	landLeaseAmount: number;
	landLeaseAmountFrequency: string;
	landLeaseAmountSource: string;
	landLeaseExpirationDate: string;
	landLeasePurchaseYN: string;
	landLeaseRenewalDate: string;
	landLeaseTransferFee: string;
	landLeaseYN: boolean;
	landUse: string;
	landValue: string;
	landValuePercent: string;
	largestContigiousSquareFootage: string;
	latitude: number;
	latitudeManual: number;
	laundryEquipmentOwnLease: string;
	laundryFeatures: string;
	laundryIncome: string;
	laundryYN: boolean;
	leasableArea: string;
	leasableAreaUnits: string;
	leaseAssignableYN: string;
	leaseConsideredYN: string;
	leaseRenewalCompensation: string;
	leaseRenewalOptionYN: string;
	leaseTerm: string;
	legalAccountingExpense: string;
	levels: string;
	license1: string;
	license2: string;
	license3: string;
	licensesExpense: string;
	listAgentAOR: string;
	listAgentBrokerKeyNumeric: number;
	listAgentBrokerMlsId: string;
	listAgentDirectPhone: string;
	listAgentDirectPhoneExt: string;
	listAgentEmail: string;
	listAgentEmailConfidential: string;
	listAgentFax: string;
	listAgentFirstName: string;
	listAgentHomePhone: string;
	listAgentHomePhoneExt: string;
	listAgentKeyNumeric: number;
	listAgentLanguages: string;
	listAgentLastName: string;
	listAgentMainOfficeKeyNumeric: number;
	listAgentMainOfficeMlsId: string;
	listAgentMlsId: string;
	listAgentMobilePhone: string;
	listAgentPager: string;
	listAgentStateLicense: string;
	listAgentTollFreePhone: string;
	listAgentTollFreePhoneExt: string;
	listAgentVoiceMail: string;
	listAgentVoiceMailExt: string;
	listingAgreement: string;
	listingContractDate: string;
	listingId: string;
	listingKeyNumeric: number;
	listingService: string;
	listingTerms: string;
	listOfficeAOR: string;
	listOfficeFax: string;
	listOfficeKeyNumeric: number;
	listOfficeMlsId: string;
	listOfficeName: string;
	listOfficePhone: string;
	listOfficePhoneExt: string;
	listOfficeStateLicense: string;
	listPrice: number;
	listPriceLow: string;
	listTeamEmail: string;
	listTeamKey: string;
	listTeamKeyNumeric: string;
	listTeamName: string;
	listTeamPreferredPhone: string;
	livingArea: number;
	livingAreaSource: string;
	livingAreaUnits: string;
	loanPayment: string;
	lockBoxLocation: string;
	lockBoxSerialNumber: string;
	lockBoxType: string;
	lockBoxVersion: string;
	longitude: number;
	longitudeManual: number;
	lotDimensionsSource: string;
	lotFeatures: string;
	lotSizeAcres: number;
	lotSizeArea: number;
	lotSizeDimensions: string;
	lotSizeSource: string;
	lotSizeSquareFeet: number;
	lotSizeUnits: string;
	mainLevelBathrooms: string;
	mainLevelBedrooms: string;
	maintenanceExpense: string;
	maintenancePercent: string;
	majorChangeTimestamp: string;
	majorChangeType: string;
	make: string;
	managementCo: string;
	managementCoPhone: string;
	managementCoPhoneExt: string;
	managerApprovalYN: boolean;
	managersFax: string;
	maxTotalArea: string;
	maxTotalAreaUnits: string;
	middleOrJuniorSchool: string;
	middleOrJuniorSchoolOther: string;
	minimumDownAmount: string;
	minTotalArea: string;
	minTotalAreaUnits: string;
	mlsAreaMajor: string;
	mobileHomeRemainsYN: boolean;
	mobileLength: number;
	mobileWidth: number;
	model: string;
	modificationTimestamp: string;
	monthlyNNN: string;
	moveIn: string;
	neighborhood: string;
	adminUpdateYN: string;
	netOperatingIncome: string;
	netProfit: string;
	newConstructionYN: string;
	newTaxesExpense: string;
	nmrSellerParticipationYN: boolean;
	numberOfBuildings: string;
	numberOfFullTimeEmployees: string;
	numberOfPads: string;
	numberOfPartTimeEmployees: string;
	numberOfRentedGarages: string;
	numberOfSeparateElectricMeters: string;
	numberOfSeparateGasMeters: string;
	numberOfSeparateWaterMeters: string;
	numberOfSheds: number;
	numberOfUnitsInCommunity: string;
	numberOfUnitsLeased: string;
	numberOfUnitsTotal: string;
	numberRemotes: string;
	numberWallAC: string;
	numberWithCarpet: string;
	numberWithDishwasher: string;
	numberWithDisposal: string;
	numberWithDrapes: string;
	numberWithPatio: string;
	numberWithRange: string;
	numberWithRefrigerator: string;
	occupancy: string;
	occupantName: string;
	occupantPhone: string;
	occupantPhoneExt: string;
	occupantType: string;
	offersEmail: string;
	officeClass: string;
	officeSquareFootage: string;
	officeSquareFootageMax: string;
	officeSquareFootageMin: string;
	officeType: string;
	offMarketDate: string;
	offMarketTimestamp: string;
	onMarketDate: string;
	onMarketTimestamp: string;
	openHouseCount: number;
	operatingExpense: string;
	operatingExpensePercent: string;
	originalEntryTimestamp: string;
	originalListPrice: number;
	originatingSystemID: string;
	originatingSystemKey: number;
	originatingSystemModificationTimestamp: string;
	otherExpense: string;
	otherExpenseDescription: string;
	otherFees: string;
	otherIncome1: string;
	otherIncome2: string;
	otherIncomeDescription: string;
	otherPhoneDescription: string;
	otherPhoneExt: string;
	otherPhoneNumber: string;
	otherStructures: string;
	ownerName: string;
	ownerPays: string;
	ownerPhone: string;
	ownershipType: string;
	parcelMaster: string;
	parcelNumber: string;
	parkingFeatures: string;
	parkingRatio: string;
	parkingTotal: number;
	parkingYN: boolean;
	parkManagerName: string;
	parkManagerPhone: string;
	parkManagerPhoneExt: string;
	parkName: string;
	patioAndPorchFeatures: string;
	patioYN: boolean;
	personalPropertyAmount: string;
	personalPropertyPercent: string;
	pestControlExpense: string;
	petsAllowed: string;
	phase: string;
	photosChangeTimestamp: string;
	photosCount: number;
	points: string;
	poolExpense: string;
	poolFeatures: string;
	poolPrivateYN: boolean;
	possession: string;
	possibleUse: string;
	possibleUseComments: string;
	postalCode: string;
	postalCodePlus4: string;
	presentLoans: string;
	previousListPrice: number;
	previousStandardStatus: string;
	priceChangeTimestamp: string;
	pricePerLotSquareFoot: string;
	pricePerSquareFoot: number;
	pricePerUnit: string;
	privateRemarks: string;
	probateAuthority: string;
	professionalManagementExpense: string;
	propertyAttachedYN: string;
	propertyCondition: string;
	propertySubType: string;
	propertyType: string;
	publicRemarks: string;
	purchaseContractDate: string;
	realEstateTaxExpense: string;
	reasonForSelling: string;
	registeredYN: boolean;
	rentControlYN: string;
	rentExcludes: string;
	rentIncludes: string;
	rentMax: string;
	rentMin: string;
	reservesExpense: string;
	residentialSquareFootage: string;
	residentManagerExpense: string;
	retailCenterType: string;
	retailSquareFootage: string;
	roadFrontageType: string;
	roadSurfaceType: string;
	roof: string;
	roomBathroomFeatures: string;
	roomKitchenFeatures: string;
	roomType: string;
	rvParkingDimensions: string;
	rvParkingFee: string;
	saleConsideredYN: string;
	seatingCapacity: string;
	securityExpense: string;
	securityFeatures: string;
	sellerInstructedToExcludeYN: string;
	seniorCommunityYN: boolean;
	serialU: string;
	serialX: string;
	serialXX: string;
	sewer: string;
	showingContactName: string;
	showingContactPhone: string;
	showingContactPhoneExt: string;
	showingContactType: string;
	showingInstructions: string;
	signage: string;
	signOnPropertyYN: boolean;
	skirt: string;
	soilType: string;
	soldCapRate: string;
	sourceSystemID: string;
	sourceSystemKey: string;
	sourceSystemModificationTimestamp: string;
	spaFeatures: string;
	spaYN: boolean;
	specialAssessments: string;
	specialLicenses: string;
	specialListingConditions: string;
	sprinklersYN: string;
	standardStatus: string;
	startShowingDate: string;
	stateOrProvince: string;
	statusChangeTimestamp: string;
	statusPriceChangeTimestamp: string;
	storiesTotal: number;
	streetDirPrefix: string;
	streetDirSuffix: string;
	streetName: string;
	streetNumber: string;
	streetNumberNumeric: number;
	streetSuffix: string;
	streetSuffixModifier: string;
	structureType: string;
	subdivisionCode: string;
	subdivisionName: string;
	subdivisionNameOther: string;
	suppliesExpense: string;
	survey: string;
	surveyType: string;
	syndicateTo: string;
	syndicationRemarks: string;
	taxAnnualAmount: string;
	taxArea: string;
	taxBlock: string;
	taxCensusTract: string;
	taxesPercent: string;
	taxLot: string;
	taxMapNumber: string;
	taxModel: string;
	taxOtherAnnualAssessmentAmount: string;
	taxOtherAnnualAssessmentAmountSource: string;
	taxParcelLetter: string;
	taxRate: string;
	taxRateTotal: string;
	taxTract: string;
	taxTractMapStatus: string;
	taxTractNumber: string;
	taxYear: string;
	tenantPays: string;
	topography: string;
	totalActualRent: string;
	totalBuildingNRA: string;
	totalExpenses: string;
	totalMonthlyRent: string;
	totalMoveInCosts: string;
	tractSubAreaCode: string;
	transferFee: string;
	transferFeePaidBy: string;
	trashExpense: string;
	trees: string;
	uncoveredSpaces: string;
	unitNumber: string;
	universalPropertyId: string;
	unparsedAddress: string;
	urlDescription: string;
	usableLandPercent: string;
	utilities: string;
	vacancyAllowance: string;
	vacancyAllowanceRate: string;
	view: string;
	viewYN: boolean;
	virtualTourURLBranded: string;
	virtualTourURLUnbranded: string;
	virtualTourURLUnbranded2: string;
	voltage: string;
	walkScore: number;
	waterBodyName: string;
	waterfrontFeatures: string;
	waterSewerExpense: string;
	waterSource: string;
	waterTableDepth: string;
	waterWellYN: string;
	wellDepth: string;
	wellGallonsPerMinute: string;
	wellHoleSize: string;
	wellPumpHorsepower: string;
	wellReportYN: string;
	windowFeatures: string;
	withdrawnDate: string;
	workmansCompensationExpense: string;
	yearBuilt: number;
	yearBuiltSource: string;
	yearEstablished: string;
	yearsCurrentOwner: string;
	zoning: string;
	zoningDescription: string;
	powerProductionYN: string;
	greenVerificationYN: string;
	rentalApplication: string;
	additionalInfo: string;
	idxContactInfo: string;
	specialConsiderations: string;
	parcelNumberAvailableYN: string;
	dpResourceYN: string;
	rentalApplicationURL: string;
	createdBy: string;
	createdOn: string;
	modifiedBy: string;
	modifiedOn: string;
}

/// Todo remove mock data
export const mockCase = {
	memberName: "Bill Nicholas",
	memberStatus: "Active",
	memberAor: "Arcadia Association of REALTORS",
	unseenChanges: false,
	ticklerAlert: false,
	tickler: "0001-01-01T00:00:00+00:00",
	reason: null,
	priority: null,
	assignName: null,
	reportIds: [
		"e8ab4a39-f2b3-43c0-2252-08dadc807608",
		"ab8f8e7a-34e0-4646-adf6-08dadeff4366",
		"dd51ded9-24af-4cc2-adf5-08dadeff4366",
		"e8ab4a39-f2b3-43c0-2252-08dadc807608",
		"ab8f8e7a-34e0-4646-adf6-08dadeff4366",
		"dd51ded9-24af-4cc2-adf5-08dadeff4366",
		"e8ab4a39-f2b3-43c0-2252-08dadc807608",
		"ab8f8e7a-34e0-4646-adf6-08dadeff4366",
		"dd51ded9-24af-4cc2-adf5-08dadeff4366",
		"e8ab4a39-f2b3-43c0-2252-08dadc807608",
		"ab8f8e7a-34e0-4646-adf6-08dadeff4366",
		"dd51ded9-24af-4cc2-adf5-08dadeff4366",
		"e8ab4a39-f2b3-43c0-2252-08dadc807608",
	],
	rulesIds: [
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"f108df6d-d748-426d-bd4a-08dabc1aa7ba",
		"1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
		"f1c6f6c9-8b85-4ca4-bd4e-08dabc1aa7ba",
	],
	rules: [
		{
			ruleNumber: "8.3",
			ruleTitle: "Display of Inaccurate Listing Status",
			warning: true,
			citationFee: 250,
			mlsRulebookText:
				"8.3  Accuracy of Information; Responsibility for Accuracy. By inputting information into the MLS computer database, the Listing Broker represents that the information input is accurate to the best of the Listing Broker’s knowledge. The Listing Broker shall use good faith efforts to determine the accuracy of the information and shall not submit or input information which the Listing Broker knows to be inaccurate. Upon receipt of the first publication or electronic transfer by the MLS of such information, the Listing Broker shall make all necessary corrections. The MLS merely publishes the MLS information and has no affirmative responsibility to verify the accuracy of the MLS information. The AOR/MLS, however, reserves the right to require Participants and Subscribers to change their MLS information if the AOR/MLS is made aware of alleged inaccuracies in the MLS information and the AOR/MLS determines that such inaccuracies do in fact exist. The MLS also reserves the right to remove a listing that contains said inaccurate information from the MLS compilation of current listings should Participant or Subscriber refuse or fail to timely correct. A Participant or Subscriber is required to correct inaccurate information within 2 days after being notified of the inaccuracies by the MLS. If a Participant or Subscriber fails to make necessary or required corrections to their MLS information, the Participant and Subscriber shall indemnify and hold harmless the AOR/MLS for any claims, cost, damage, or losses, including reasonable attorney fees and court costs, incurred by the MLS as a result of such failure. The AOR/MLS also reserves the right to remove information and listings from the database when it is clear that inaccurate data has been entered, in addition to disciplining the Participant and Subscriber for violations of the MLS rules. In no event will the AOR/MLS be liable to any Participant, Subscriber, or any other party for any indirect, special, or consequential damages arising out of any information published in the MLS, and all other damages shall be limited to an amount not to exceed the MLS fees paid by the Listing Broker. ",
			processingGuideline:
				"Policy: To investigate all reports made regarding inaccurate statuses and ensure that all information entered on the MLS is accurate.\r\n                                              Application:\r\n                                              1.This violation usually occurs when a report is received regarding a property that is not available for showings and is listed as Active on the MLS.Other reports include listings that are currently Active on the MLS but should be Withdrawn by the brokerage, per the request of the seller(s).\r\n                                              Comments:\r\n                                              1.A listing that has not been updated to reflect the acceptance of an offer is NOT handled under this Rule.Please refer to Rule 10.2 for further processing regarding reports of Active listings that should be Pending or Active Under Contract.\r\n                                              \r\n                                                   35\r\n                                              Procedures:\r\n                                              1.Issue a Warning Notice to the listing agent.\r\n                                              a.WARNING NOTICE: This notice will advise the listing agent of the report received and will request the listing agent either make the necessary modification(s), or, respond to the warning and advise that the current status is correct within 2 business days to prevent the issuance of a citation.All brokers and office managers will be copied on this notice and the Association contact will be BCC’d.\r\n                                              2.If evidence proving the inaccurate status is provided by the reporting agent and corrective action is not taken within the time frame provided on the Warning Notice, a Citation will be issued for violating section 8.3 – Inaccurate Information.The status will be modified by CRMLS Staff.\r\n                                              a.CITATION NOTICE: This notice will reiterate the report received and will reference the fact that we reached out on[DATE] and requested the necessary modification be made within 2 business days.Because corrective action was not taken within the allotted time frame on the Warning Notice, a citation was issued.Note all modifications made by CRMLS Staff and copy all brokers and office managers on this notice.The Association contact will be BCC’d.\r\n                                              3.If evidence is not received and corrective action is not taken, reissue a Warning Notice, as outlined above and reference this as our second attempt at resolving the violation.As noted above, all brokers and office managers are to be copied and the Association contact is to be BCC’d.If corrective action is still not taken, close the case as Unable to Verify and advise the reporting party that the listing was not found in violation at this time.Request additional information from the reporting party to assist in our investigation.\r\n                                              4.If additional information is provided, we can reopen the case or create a new case.\r\n                                              5.If the listing status was modified prior to your review of the report, correcting the violation, close the case as Corrected and advise the reporting party of this resolution.",
			emailTemplate: "N/A",
			createdBy: "",
			createdOn: "2022-11-01T11:06:29.5773977-04:00",
			id: "f108df6d-d748-426d-bd4a-08dabc1aa7ba",
			modifiedBy: "",
			modifiedOn: "2022-11-01T11:06:29.5773977-04:00",
		},
		{
			ruleNumber: "13.2",
			ruleTitle: "Unauthorized Sharing of Lockbox Key",
			warning: false,
			citationFee: 1500,
			mlsRulebookText:
				"<p>Key Use and Service. Keys may not be used under any circumstances by anyone other than the key holder, including, but not limiting to, lending, borrowing or sharing keys with others. Access codes may not be provided to third-parties without the consent of the seller. The AOR/MLS is not obligated to provide service on keys or lockboxes to an individual who is not the registered lessee or owner of the component. The key will only be used for the purpose of facilitating the sale/lease of a property.</p>",
			processingGuideline:
				"<p>Policy: To investigate and aggressively enforce this rule to prevent the sharing of Lockbox keys and unauthorized entry to a listed property. '</p>\n<p>These infractions are considered very serious due to the property and privacy rights of the homeowners. Application:</p>\n<p>1. Reports of this violation are typically made when the person accessing the property is not the actual agent registered to the Supra Key.</p>\n<p>2. The typical scenario found is an agent or broker sends an assistant with their Supra Key to access the property on their behalf.</p>\n<p>3. This violation is not limited to the use of Supra Keys. Accessing the property by entry of a combo lock or other lockbox in which the person at the property is not the actual agent that communicated with the listing agent is also a violation.</p>\n<p>4. All evidence must be saved and attached to the case prior to the issuance of a citation. Procedures: Upon receipt of a report, make a case in Salesforce if there is not already one in an open status. Review all evidence to determine if a violation of this rule occurred.</p>\n<p>1. If enough evidence was not provided by the reporting agent, send a follow-up/confirmation of report received and request they provide additional information regarding their report. a. If additional information is provided, proceed to step 3. b. If additional information is not provided, proceed to step 2. 2. If enough evidence is not provided by the reporting party after our follow-up confirmation, reach out to the reported agent via an inquiry to confirm they were the person to access the property. a. Inquiry: In this notice, advise the reported agent of the report received and request that they confirm they were the person at the property. Copy all Brokers and Office Managers on the inquiry. b. If they state they were the person accessing the property, close the case as AOR Referral and request the reporting party reach out to the reported agent&rsquo;s AOR&rsquo;s Pro Standard Administrator to file a grievance. 78 c. If they admit an assistant or other person was sent to the property on their behalf, issue a Citation. i. Citation Notice: Reference the report received and include all evidence used to determine the outcome of the investigation. All admissions MUST be included in this notice. Copy all Brokers and Office Managers and include the Association Contact as a BCC. 3. If enough evidence is provided, issue a Citation. a. Citation Notice: Reference the report received and include all evidence used to determine the outcome of the investigation. Copy all Brokers and Office Managers and include the Association Contact as a BCC.</p>",
			emailTemplate: "<p>N/A</p>",
			createdBy: "",
			createdOn: "2022-11-01T11:06:31.2879652-04:00",
			id: "1dbcabe6-b48d-4749-bd4f-08dabc1aa7ba",
			modifiedBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
			modifiedOn: "2023-01-12T19:23:35.1019952+00:00",
		},
		{
			ruleNumber: "10.2",
			ruleTitle: "Failure to Timely Report Listing Status Chanes and Sales",
			warning: false,
			citationFee: 250,
			mlsRulebookText:
				"a) Listings with accepted offers shall be reported to the MLS or input into the MLS database as “pending” or “active under contract” within 2 business days of the acceptance by the Listing Broker unless the negotiations were carried on under Section 9.1 (a) or (b), in which case, the Buyer Broker shall notify the Listing Broker of the “pending” or “active under contract” status within 2 business days after acceptance, whereby the Listing Broker shall then report or input the status change to the MLS within 2 business days of receiving notice from the Buyer Broker.\r\n                                            b) The listing shall be published on the MLS as “pending” or “active under contract” with no price or terms prior to the final closing.\r\n                                            c) Upon final closing, the Listing Broker shall report or input the listing in the MLS as “sold” and report the selling price within 2 business days of the final closing date unless the negotiations were carried on under Section 9.1 (a) or (b), in which case, the Buyer Broker shall notify the Listing Broker of the “sold” status and selling price within 2 business days after the final closing date, whereby the Listing Broker shall then report or input the status change and selling price to the MLS within 2 business days of receiving notice from the Buyer Broker.\r\n                                            d) Listings which were not input into the MLS as a result of the seller’s(s’) instructions may be input into the MLS “sold” data at the Listing Broker's option. However, listings which were input into the MLS but subsequently withdrawn must still be reported under this section if the seller is represented by the Listing Broker when it closes.\r\n                                            e) The MLS may accept the reporting of sales information for comparable purposes about other properties which were not otherwise eligible for input into the MLS but are located in the MLS’s service area and “sold” by an MLS participant and/or subscriber who represented a party in the transaction (i.e. broker who represented the seller or broker who represented the buyer), as long as such reporting is authorized by a party in the transaction to the broker who represented it, (if requested by the MLS documentation must be presented to MLS within 2 business days), and the circumstances of the representation are disclosed on the Service by the reporting participant or subscriber. Any submission of sales information must occur within 2 business days after close of escrow.",
			processingGuideline:
				"Policy: To maintain the quality of data by investigating reports of late reporting of sales and late reporting of acceptance of offers.\r\n                                                Application:\r\n                                                1. This violation typically occurs when a listing is not changed to Pending or Active Under Contract upon the seller(s)’s acceptance of an offer, resulting in the status change from Active to Sold on the same day. In those cases, the agent violated this rule because the acceptance of the offer was never reported on the MLS.\r\n                                                   37\r\n                                                2. Another common report involves a listing that is displaying a status of Pending or Active Under Contract but should be in the status of Closed. In this instance, the agent failed to update the listing upon the property closing escrow.\r\n                                                Comments:\r\n                                                1. Listings that display a status of Auto Sold (noted with a red flag) are NOT to be processed under this rule. Reference Rule 8.3 – Auto Sold for instructions on how to process under the associated violation.\r\n                                                2. Pending should be used when an offer is accepted, and the seller(s) is not accepting back- up offers. If back-up offers are being accepted, Active Under Contract is the proper status. However, it is up to the broker to decide which status is to be used. Compliance does not make that decision for the listing agent or broker.\r\n                                                Procedures:\r\n                                                1. Upon review of the report, verify the current status of the listing.\r\n                                                2. If the listing is still in a status other than Pending, Active under Contract, or Closed, send an\r\n                                                inquiry.\r\n                                                a. Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent either confirm that the current status is correct, or, make the necessary updates. Provide the agent a corrective action deadline of 2 business days and copy all brokers and office managers.\r\n                                                b. If corrective action is not taken within the 2 business days, request additional information from the reporting party as a separate inquiry. If additional information is not provided, close the case as Unable to Verify and make a note that a violation was not determined at this time due to insufficient evidence If additional information is provided, such as a copy of an email thread or text message between the reporting party and the listing agent, and the listing is found to be in an inaccurate status based on an admission from the listing agent, issue a Citation Notice under Rule 10.2.\r\n                                                i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received and request that the listing agent make the necessary changes to the listing within 2 business days. All brokers and office managers will be copied on this notice and the Association contact will be BCC’d.\r\n                                                ii. If corrective action is not taken within 2 business days after the issuance of a citation, issue another Citation under Rule 14.4. Reference this section for instructions how to proceed.\r\n                                                3. If the listing status was updated prior to your review of the report and is Pending, send an inquiry and request a copy of the signed purchase agreement.\r\n                                                a. Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent\r\n                                                  38\r\n                                                \r\n                                                provide CRMLS with a copy of the signed purchase agreement for the accepted offer. Provide the agent with a corrective action deadline of 2 business days. All brokers and office managers will be copied on this notice.\r\n                                                b. Review of Documentation: Upon receipt of the signed purchase agreement, verify that the purchase contract date on the MLS is consistent with the date of the accepted offer.\r\n                                                c. If the dates are consistent but the change in status was made after the 2-business day time frame, as outlined in Rule 10.2, issue a Citation.\r\n                                                i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received. All brokers and office managers will be copied on this notice and the Association contact will be BCC’d.\r\n                                                This violation CANNOT be corrected.\r\n                                                d. If the date on the MLS is inconsistent with the documentation provided, follow-up with the agent via email and request if any other documentation, such as signed counter offers, can be provided which would support the date on the MLS.\r\n                                                e. If additional documentation cannot be provided, issue a Citation under Rule 10.2, as outlined above. Upon the issuance of the citation, modify the purchase contract date to reflect the signed purchase agreement.\r\n                                                f. If additional documentation is provided and matches the MLS but the change was made outside of the 2-business day timeframe, issue a Citation under Rule 10.2, as outlined above.\r\n                                                4. If the listing status was updated prior to your review of the report and is Closed, send an inquiry and request a copy of the Final Closing Statement.\r\n                                                a. Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent provide CRMLS with a copy of the Final Closing Statement. Provide the agent with a corrective action deadline of 2 business days. All brokers and office managers will be copied on this notice.\r\n                                                b. Review of Documentation: Upon receipt of the Final Closing Statement, verify that the Reported Date on the document is consistent with the close of escrow date on the MLS.\r\n                                                c. If the dates are consistent but the change in status was made after the 2-business day time frame, as outlined in Rule 10.2, issue a Citation Notice.\r\n                                                i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received. All brokers and office managers will be copied on this notice and the Association contact will be BCC’d. This violation CANNOT be corrected.\r\n                                                39\r\n                                                \r\n                                                d. If the date on the MLS is inconsistent with the documentation provided, modify the close of escrow date to reflect the closing statement and issue a Citation under Rule 10.2, as outlined above, if the status change occurred more than 2 business days from the close of escrow date.",
			emailTemplate: "N/A",
			createdBy: "",
			createdOn: "2022-11-01T11:06:30.1631807-04:00",
			id: "b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
			modifiedBy: "",
			modifiedOn: "2022-11-01T11:06:30.1631807-04:00",
		},
	],
	memberId: "e96f07d3-2fca-4a16-816b-752a758e0be9",
	assignTo: "00000000-0000-0000-0000-000000000000",
	referenceNumber: null,
	firstNotifiedOn: "0001-01-01T00:00:00+00:00",
	closedOn: "0001-01-01T00:00:00+00:00",
	caseObject: null,
	disposition: "CaseDispositions.InAppeal",
	status: "Closed",
	listingId: "PW19234310",
	description:
		"Accuracy of Information; Responsibility for Accuracy. By inputting information into the MLS computer database, the Listing Broker represents that the information input is accurate to the best of the Listing Broker’s knowledge. The Listing Broker shall use good faith efforts to determine the accuracy of the information and shall not submit or input information which the Listing Broker knows to be inaccurate. Upon receipt of the first publication or electronic transfer by the MLS of such information, the Listing Broker shall make all necessary corrections. The MLS merely publishes the MLS information and has no affirmative responsibility to verify the accuracy of the MLS information. The AOR/MLS, however, reserves the right to require Participants and Subscribers to change their MLS information if the AOR/MLS is made aware of alleged inaccuracies in the MLS information and the AOR/MLS determines that such inaccuracies do in fact exist. The MLS also reserves the right to remove a listing that contains said inaccurate information from the MLS compilation of current listings should Participant or Subscriber refuse or fail to timely correct. A Participant or Subscriber is required to correct inaccurate information within 2 days after being notified of the inaccuracies by the MLS. If a Participant or Subscriber fails to make necessary or required corrections to their MLS information, the Participant and Subscriber shall indemnify and hold harmless the AOR/MLS for any claims, cost, damage, or losses, including reasonable attorney fees and court costs, incurred by the MLS as a result of such failure. The AOR/MLS also reserves the right to remove information and listings from the database when it is clear that inaccurate data has been entered, in addition to disciplining the Participant and Subscriber for violations of the MLS rules. In no event will the AOR/MLS be liable to any Participant, Subscriber, or any other party for any indirect, special, or consequential damages arising out of any information published in the MLS, and all other damages shall be limited to an amount not to exceed the MLS fees paid by the Listing Broker. ",
	caseNumber: "AA 1.01",
	createdBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	createdOn: "2023-01-10T19:59:37.2817659+00:00",
	id: "0c573855-634e-43af-405a-08daf344bac7",
	modifiedBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	modifiedOn: "2023-01-24T15:58:32.8280147+00:00",
	violations: [],
	violationIds: [],
};

export const mockChatLogNotice: NoticeDefinitionEntityProperties = {
	violationIds: ["d2265035-67c2-45a4-e5df-08db45c72407", "7387163b-6d6f-46dd-e5e0-08db45c72407"],
	chatLog: [
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "analyst",
			sender: "Jane Smith",
			text: "Hi John, I am your compliance analyst and I'll be handling your case today.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "agent",
			sender: "John Smith",
			text: "That sounds great.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "analyst",
			sender: "Jane Smith",
			text: "There appears to be some reports on one of your listings. Is now a good time to go over them?",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "agent",
			sender: "John Smith",
			text: "Yes, I'm ready to get started.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "analyst",
			sender: "Jane Smith",
			text: "The first reports says that you have some pictures on your listing that are not allowed.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "agent",
			sender: "John Smith",
			text: "I'll take them down immediately, thank you.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "analyst",
			sender: "Jane Smith",
			text: "There are also reports on listing #128 4br Rockwood Dr. is actually a 1 BR.",
		},
		{
			date: "2023-04-29T17:57:06.053+00:00",
			user: "agent",
			sender: "John Smith",
			text: "I must have entered 4 bedrooms in error. I will correct it.",
		},
	],
	violations: [
		{
			complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
			mlsRuleId: "750909b8-17c0-469d-bd4b-08dabc1aa7ba",
			mlsRule: {
				ruleNumber: "12.8.1",
				ruleTitle: "Displaying Unauthorized Photograph on Neighborhood Market Report",
				warning: false,
				citationFee: 10,
				mlsRulebookText:
					"Advertising of Listing in Printed Neighborhood Market Report.\r\n                                          Subject to the conditions set forth in (a)through(c) below, as well as throughout these Rules,\r\n                                          Participants and Subscribers may include the listings of others in their printed “Neighborhood Market Reports.” The “Neighborhood Market Report” is defined as an advertising and / or information sheet(typically appearing in the form of a postcard, flier or newsletter) compiled by and / or for use by a licensee which sets forth a list of home activity in a particular neighborhood area.Advertising appearing in newspapers, magazines or other classified forms is not included in the definition of “Neighborhood Market Report” and is not authorized by this Rule 12.8.1.\r\n                                          c) Allowable Listing Content.Broker Participants and Subscribers may include only those portions of the MLS compilation consisting of the following: property address(and whether attached or detached), status, price, number of bedrooms, number of bathrooms, number of garages(and whether attached or detached), square footage, lot size, year built, tract or development name, and if there’s a pool.Display of other fields, as well as confidential information and photographs, is prohibited.",
				processingGuideline:
					"Policy: To investigate reports of this violation and enforce this rule to prevent the use of prohibited and confidential information on the MLS.\r\n                                               Application:\r\n                                               9. The most common reports received under this subsection include Neighborhood Market Reports (NMR) which advertise confidential information, such as compensation amounts, Days on Market (DOM), and list prices. The inclusion of photographs is not permitted.\r\n                                               a. A violation for the inclusion of prohibited or confidential information results in a fine in the amount of $250.\r\n                                               b. A violation for the inclusion of an unauthorized photograph results in a fine in the amount of $1,500.\r\n                                               10. Flyers are not the same as NMRs. NMRs have a grid-like layout, similar to Matrix’s Agent 1- line display, and usually include minimal information such as the bedroom count, bathroom count, square footage, address, and status. The information on an NMR is also concentrated to include a specific area.\r\n                                               11. A copy of each side of the Neighborhood Market Report must be saved as evidence and attached to the case prior to issuing a citation.\r\n                                                  65\r\n                                               Procedures:\r\n                                               9. Review the information displayed on the NMR and confirm that all data is accessible by public records.\r\n                                               10. If the NMR reported does not include prohibited or confidential information, close the case as No Violation.\r\n                                               11. If the NMR includes information that is prohibited or deemed confidential, issue a Citation:\r\n                                               a. Citation Notice: This notice will reference the rule and include all information gathered as evidence to conclude our investigation. The NMR received will be referenced as well as which specific fields or information were inappropriately advertised. All brokers and office managers will be copied on this notice and the Association contact will be included as a BCC.\r\n                                               12. If the flyer is found to be in violation of other Rules, such as 12.8.1(a) for the use of unauthorized listings or 12.8.1(b) for not including proper attribution, issue a new Citation Notice under such rule. Reference the appropriate section for instructions on how to proceed with your investigation.",
				emailTemplate: "N/A",
				fineType: "fixed",
				createdBy: "",
				createdOn: "2022-11-01T11:06:29.8775198-04:00",
				id: "750909b8-17c0-469d-bd4b-08dabc1aa7ba",
				modifiedBy: "",
				modifiedOn: "2022-11-01T11:06:29.8775198-04:00",
			},
			enumerationLookupId: "",
			corrected: false,
			createdOn: "2023-04-25T19:56:20.8371784+00:00",
			id: "d2265035-67c2-45a4-e5df-08db45c72407",
		},
		{
			complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
			mlsRuleId: "f1c6f6c9-8b85-4ca4-bd4e-08dabc1aa7ba",
			mlsRule: {
				ruleNumber: "7.8",
				ruleTitle: "Failure to Input Listing in MLS or Register Property",
				warning: false,
				citationFee: 10,
				mlsRulebookText:
					"<p>Within 2 business days after all necessary signatures of the seller(s) have been obtained on the listing, or at the beginning date of the listing as specified in the contract, whichever is later, on any exclusive right to sell/lease or seller reserved listing on one to four unit residential property and vacant lots located within the service area of the MLS, Broker Participants shall (1) input the listing to the service, or (2) submit a seller-signed exclusion in accordance with Section 7.9 (Exempted Listings) to the AOR/MLS. All necessary signatures are those needed to create an enforceable listing, which generally means all named signatories to the listing agreement. In the event there are known additional property owners not made a signatory to the listing, the Listing Broker shall disclose said fact to the AOR/MLS and state whether the listed seller will make the sale contingent on the consent of the additional property owners. In the event the listing agent is prevented from complying with the 2-business day time period due to seller&rsquo;s delay in returning the signed listing agreement, the Listing Broker must submit the listing to the MLS within 2 business days of receipt back from seller. The AOR/MLS may require the Listing Broker to present documentation to the AOR/MLS evidencing the seller&rsquo;s delayed transmission. Only those listings that are within the service area of the MLS must be input. Open listings or listings of property located outside the MLS's service area (see Section 7.10) are not required by the MLS but may be input at the Broker Participant&rsquo;s option.</p>",
				processingGuideline:
					'<div class="page" title="Page 12">\n<div class="layoutArea">\n<div class="column">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">WARNING: NO </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Policy: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">Investigate and have the agent: 1. Enter the listing into the MLS, or; 2. file an exclusion form with the MLS. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Application: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">1. When an agent fails to either: 1. Enter a listing into the MLS, or; 2. File an exclusion form with the MLS within 2 business days of the effective list date. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Comments: </span></p>\n<ol style="list-style-type: decimal;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">This Rule is often implicated when a reporting agent notices a property has a for sale or coming soon sign out front, or is being promoted on social media, and the reporting agent then goes to the MLS and does not find the property listed. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is an exclusion form on file with the MLS and the exclusion period has not yet expired, this will not be a violation. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the agent on the advertisement is NOT a member of CRMLS, we cannot begin an investigation. The report will need to be forwarded to the appropriate MLS and the reporting party is to be informed of this information. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">CRMLS has the right to request a copy of a listing agreement even if the listing is not yet entered to the MLS. Per Section 8.2 of the CRMLS Rules and Regulations, a copy of the listing agreement may be requested at any time.</span></p>\n</li>\n</ol>\n</div>\n</div>\n</div>\n<div class="page" title="Page 13">\n<div class="layoutArea">\n<div class="column">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Procedures: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">1. Upon receipt of the report check to see if 1) the violating agent is a member of CRMLS, 2) if an exclusion form was filed with the MLS for the property reported, and 3) if the property was entered in the MLS. </span></p>\n<ol style="list-style-type: lower-latin;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the agent is NOT a member of CRMLS, this will not be a violation. The report will be forwarded to the appropriate MLS and the reporting agent is to be informed of this information. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is an exclusion form on file with the MLS and the exclusion period has not yet expired, this will not be a violation. Create a Task to follow up and review for the date in the Exclusion Form that the property should be placed in the MLS. Verify that the DOM is accurate in the listing. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is no listing on the MLS nor was an exclusion form filed with the MLS within 2 business days of the receipt of the report, and the advertising agent is a member of CRMLS, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Section 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. A case must be created which will contain the initial report and all photographic evidence. </span></p>\n</li>\n</ol>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">Because this rule does not require a warning to be sent prior to the issuance of a citation, a citation will be issued under the assumption there is a valid listing agreement in place. A case will be created under the agent on the for-sale sign or other advertisement. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. Within 2 business days, the agent must either enter the listing into the MLS or file an exclusion form. If neither is done, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 14.4</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. Reference this section for instructions on how to proceed. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">2. If there is a listing on the MLS, search for a filed exclusion form then look at the List Contract Date on the listing. If the listing was entered into the MLS after the report was provided to Compliance, create a case and request a copy of the complete listing agreement (under the authority of CRMLS Rule 8.2) via an </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">inquiry </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">email to the agent. CC all brokers and office managers. At this time, we are requesting the agreement to ensure all information entered on the MLS is accurate. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">3. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Review of Listing Agreements</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">: A complete listing agreement consists of having the following: a beginning date and end date, an identified property, an identified seller(s), an identified brokerage, a compensation amount (unless Open Listing), and all necessary signatures and signature dates. </span></p>\n<ol style="list-style-type: lower-latin;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the listing agreement is complete and all dates match the listing on the MLS, the case will be closed as an AOR Referral and the reporting party will need to be referred to the listing agent&rsquo;s Association&rsquo;s Pro Standards Committee. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the listing agreement became effective more than 2 business days prior to the entry into the MLS, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">.</span></p>\n</li>\n</ol>\n</div>\n</div>\n</div>\n<div class="page" title="Page 14">\n<div class="layoutArea">\n<div class="column">\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">The citation will be issued based on the evidence that the listing was not entered into the MLS within the 2-business day time frame, nor was an exclusion filed with the MLS. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. This is a non-correctable violation as the late entry cannot be resolved. </span></p>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">c. If the effective list date of the agreement does NOT match the list contract date on the listing and more than 2 business days passed before entering the property into the MLS, CRMLS will request additional documentation, such as a signed Modification of Terms, that supports the date entered on the MLS via an </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">inquiry </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">email. All brokers and office managers will be copied on this request. </span></p>\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. If supporting documentation can be provided, the case will be closed as No Violation and the reporting party will be advised of this resolution. </span></p>\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">ii. If no documentation can be provided, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. </span></p>\n<p style="padding-left: 120px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">a. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">The citation will be issued based on the evidence that the listing was not entered into the MLS within the 2-business day time frame, nor was an exclusion filed with the MLS. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. This is a non-correctable violation as the late entry cannot be resolved. Upon the issuance of this citation, the effective list date on the MLS must be updated to reflect the listing agreement provided. </span></p>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">d. If the agent and the broker fail to provide a copy of the complete listing agreement by the requested deadline on any inquiry outlined above, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 8.2</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. Please reference this section for the issuance of this citation. </span></p>\n</div>\n</div>\n</div>',
				emailTemplate: "<p>Gotta enter yer listings bro.</p>",
				fineType: "fixed",
				createdBy: "",
				createdOn: "2022-11-01T11:06:30.8657997-04:00",
				id: "f1c6f6c9-8b85-4ca4-bd4e-08dabc1aa7ba",
				modifiedBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
				modifiedOn: "2022-11-07T18:59:08.754788+00:00",
			},
			enumerationLookupId: "",
			corrected: true,
			createdOn: "2023-04-25T19:56:20.8645829+00:00",
			id: "7387163b-6d6f-46dd-e5e0-08db45c72407",
		},
	],
	createdByName: "Robert Maher",
	name: "",
	displayName: "",
	templateName: "",
	expiresOn: "0001-01-01T00:00:00+00:00",
	policyReference: "",
	fineAmount: "20",
	actionClassName: "",
	noticeType: "NoticeType.Chat",
	status: "",
	activeOn: "0001-01-01T00:00:00+00:00",
	reportViolationId: "00000000-0000-0000-0000-000000000000",
	correctiveActionDeadline: "2023-04-29T17:57:06.053+00:00",
	complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
	complianceCase: {} as any,
	reviewDeadline: "",
	suspensionDate: "",
	combineWith: "00000000-0000-0000-0000-000000000000",
	ccEmails: "",
	ccAor: "",
	ccOfice: "",
	description: "",
	statement: "<p>This is a test</p>",
	correctiveAction: "This is a test",
	analystNote: "This is a test",
	corrected: true,
	issuedFailureToCorrect: true,
	createdBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	createdOn: "2023-04-26T17:57:18.0609634+00:00",
	id: "mock-data-id-828337437382828",
	modifiedBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	modifiedOn: "2023-04-26T17:57:18.0609634+00:00",
} as any;

export const mockCallNotice: NoticeDefinitionEntityProperties = {
	violationIds: ["d2265035-67c2-45a4-e5df-08db45c72407", "7387163b-6d6f-46dd-e5e0-08db45c72407"],
	violations: [
		{
			complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
			mlsRuleId: "750909b8-17c0-469d-bd4b-08dabc1aa7ba",
			mlsRule: {
				ruleNumber: "12.8.1",
				ruleTitle: "Displaying Unauthorized Photograph on Neighborhood Market Report",
				warning: false,
				citationFee: 10,
				mlsRulebookText:
					"Advertising of Listing in Printed Neighborhood Market Report.\r\n                                          Subject to the conditions set forth in (a)through(c) below, as well as throughout these Rules,\r\n                                          Participants and Subscribers may include the listings of others in their printed “Neighborhood Market Reports.” The “Neighborhood Market Report” is defined as an advertising and / or information sheet(typically appearing in the form of a postcard, flier or newsletter) compiled by and / or for use by a licensee which sets forth a list of home activity in a particular neighborhood area.Advertising appearing in newspapers, magazines or other classified forms is not included in the definition of “Neighborhood Market Report” and is not authorized by this Rule 12.8.1.\r\n                                          c) Allowable Listing Content.Broker Participants and Subscribers may include only those portions of the MLS compilation consisting of the following: property address(and whether attached or detached), status, price, number of bedrooms, number of bathrooms, number of garages(and whether attached or detached), square footage, lot size, year built, tract or development name, and if there’s a pool.Display of other fields, as well as confidential information and photographs, is prohibited.",
				processingGuideline:
					"Policy: To investigate reports of this violation and enforce this rule to prevent the use of prohibited and confidential information on the MLS.\r\n                                               Application:\r\n                                               9. The most common reports received under this subsection include Neighborhood Market Reports (NMR) which advertise confidential information, such as compensation amounts, Days on Market (DOM), and list prices. The inclusion of photographs is not permitted.\r\n                                               a. A violation for the inclusion of prohibited or confidential information results in a fine in the amount of $250.\r\n                                               b. A violation for the inclusion of an unauthorized photograph results in a fine in the amount of $1,500.\r\n                                               10. Flyers are not the same as NMRs. NMRs have a grid-like layout, similar to Matrix’s Agent 1- line display, and usually include minimal information such as the bedroom count, bathroom count, square footage, address, and status. The information on an NMR is also concentrated to include a specific area.\r\n                                               11. A copy of each side of the Neighborhood Market Report must be saved as evidence and attached to the case prior to issuing a citation.\r\n                                                  65\r\n                                               Procedures:\r\n                                               9. Review the information displayed on the NMR and confirm that all data is accessible by public records.\r\n                                               10. If the NMR reported does not include prohibited or confidential information, close the case as No Violation.\r\n                                               11. If the NMR includes information that is prohibited or deemed confidential, issue a Citation:\r\n                                               a. Citation Notice: This notice will reference the rule and include all information gathered as evidence to conclude our investigation. The NMR received will be referenced as well as which specific fields or information were inappropriately advertised. All brokers and office managers will be copied on this notice and the Association contact will be included as a BCC.\r\n                                               12. If the flyer is found to be in violation of other Rules, such as 12.8.1(a) for the use of unauthorized listings or 12.8.1(b) for not including proper attribution, issue a new Citation Notice under such rule. Reference the appropriate section for instructions on how to proceed with your investigation.",
				emailTemplate: "N/A",
				fineType: "fixed",
				createdBy: "",
				createdOn: "2022-11-01T11:06:29.8775198-04:00",
				id: "750909b8-17c0-469d-bd4b-08dabc1aa7ba",
				modifiedBy: "",
				modifiedOn: "2022-11-01T11:06:29.8775198-04:00",
			} as any,
			enumerationLookupId: "",
			corrected: false,
			createdOn: "2023-04-25T19:56:20.8371784+00:00",
			id: "d2265035-67c2-45a4-e5df-08db45c72407",
		},
		{
			complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
			mlsRuleId: "f1c6f6c9-8b85-4ca4-bd4e-08dabc1aa7ba",
			mlsRule: {
				ruleNumber: "7.8",
				ruleTitle: "Failure to Input Listing in MLS or Register Property",
				warning: false,
				citationFee: 10,
				mlsRulebookText:
					"<p>Within 2 business days after all necessary signatures of the seller(s) have been obtained on the listing, or at the beginning date of the listing as specified in the contract, whichever is later, on any exclusive right to sell/lease or seller reserved listing on one to four unit residential property and vacant lots located within the service area of the MLS, Broker Participants shall (1) input the listing to the service, or (2) submit a seller-signed exclusion in accordance with Section 7.9 (Exempted Listings) to the AOR/MLS. All necessary signatures are those needed to create an enforceable listing, which generally means all named signatories to the listing agreement. In the event there are known additional property owners not made a signatory to the listing, the Listing Broker shall disclose said fact to the AOR/MLS and state whether the listed seller will make the sale contingent on the consent of the additional property owners. In the event the listing agent is prevented from complying with the 2-business day time period due to seller&rsquo;s delay in returning the signed listing agreement, the Listing Broker must submit the listing to the MLS within 2 business days of receipt back from seller. The AOR/MLS may require the Listing Broker to present documentation to the AOR/MLS evidencing the seller&rsquo;s delayed transmission. Only those listings that are within the service area of the MLS must be input. Open listings or listings of property located outside the MLS's service area (see Section 7.10) are not required by the MLS but may be input at the Broker Participant&rsquo;s option.</p>",
				processingGuideline:
					'<div class="page" title="Page 12">\n<div class="layoutArea">\n<div class="column">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">WARNING: NO </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Policy: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">Investigate and have the agent: 1. Enter the listing into the MLS, or; 2. file an exclusion form with the MLS. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Application: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">1. When an agent fails to either: 1. Enter a listing into the MLS, or; 2. File an exclusion form with the MLS within 2 business days of the effective list date. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Comments: </span></p>\n<ol style="list-style-type: decimal;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">This Rule is often implicated when a reporting agent notices a property has a for sale or coming soon sign out front, or is being promoted on social media, and the reporting agent then goes to the MLS and does not find the property listed. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is an exclusion form on file with the MLS and the exclusion period has not yet expired, this will not be a violation. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the agent on the advertisement is NOT a member of CRMLS, we cannot begin an investigation. The report will need to be forwarded to the appropriate MLS and the reporting party is to be informed of this information. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">CRMLS has the right to request a copy of a listing agreement even if the listing is not yet entered to the MLS. Per Section 8.2 of the CRMLS Rules and Regulations, a copy of the listing agreement may be requested at any time.</span></p>\n</li>\n</ol>\n</div>\n</div>\n</div>\n<div class="page" title="Page 13">\n<div class="layoutArea">\n<div class="column">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Procedures: </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">1. Upon receipt of the report check to see if 1) the violating agent is a member of CRMLS, 2) if an exclusion form was filed with the MLS for the property reported, and 3) if the property was entered in the MLS. </span></p>\n<ol style="list-style-type: lower-latin;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the agent is NOT a member of CRMLS, this will not be a violation. The report will be forwarded to the appropriate MLS and the reporting agent is to be informed of this information. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is an exclusion form on file with the MLS and the exclusion period has not yet expired, this will not be a violation. Create a Task to follow up and review for the date in the Exclusion Form that the property should be placed in the MLS. Verify that the DOM is accurate in the listing. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If there is no listing on the MLS nor was an exclusion form filed with the MLS within 2 business days of the receipt of the report, and the advertising agent is a member of CRMLS, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Section 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. A case must be created which will contain the initial report and all photographic evidence. </span></p>\n</li>\n</ol>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">Because this rule does not require a warning to be sent prior to the issuance of a citation, a citation will be issued under the assumption there is a valid listing agreement in place. A case will be created under the agent on the for-sale sign or other advertisement. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. Within 2 business days, the agent must either enter the listing into the MLS or file an exclusion form. If neither is done, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 14.4</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. Reference this section for instructions on how to proceed. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">2. If there is a listing on the MLS, search for a filed exclusion form then look at the List Contract Date on the listing. If the listing was entered into the MLS after the report was provided to Compliance, create a case and request a copy of the complete listing agreement (under the authority of CRMLS Rule 8.2) via an </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">inquiry </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">email to the agent. CC all brokers and office managers. At this time, we are requesting the agreement to ensure all information entered on the MLS is accurate. </span></p>\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">3. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">Review of Listing Agreements</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">: A complete listing agreement consists of having the following: a beginning date and end date, an identified property, an identified seller(s), an identified brokerage, a compensation amount (unless Open Listing), and all necessary signatures and signature dates. </span></p>\n<ol style="list-style-type: lower-latin;">\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the listing agreement is complete and all dates match the listing on the MLS, the case will be closed as an AOR Referral and the reporting party will need to be referred to the listing agent&rsquo;s Association&rsquo;s Pro Standards Committee. </span></p>\n</li>\n<li style="font-size: 11.000000pt; font-family: \'Ebrima\';">\n<p><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">If the listing agreement became effective more than 2 business days prior to the entry into the MLS, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">.</span></p>\n</li>\n</ol>\n</div>\n</div>\n</div>\n<div class="page" title="Page 14">\n<div class="layoutArea">\n<div class="column">\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">The citation will be issued based on the evidence that the listing was not entered into the MLS within the 2-business day time frame, nor was an exclusion filed with the MLS. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. This is a non-correctable violation as the late entry cannot be resolved. </span></p>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">c. If the effective list date of the agreement does NOT match the list contract date on the listing and more than 2 business days passed before entering the property into the MLS, CRMLS will request additional documentation, such as a signed Modification of Terms, that supports the date entered on the MLS via an </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold;">inquiry </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">email. All brokers and office managers will be copied on this request. </span></p>\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">i. If supporting documentation can be provided, the case will be closed as No Violation and the reporting party will be advised of this resolution. </span></p>\n<p style="padding-left: 80px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">ii. If no documentation can be provided, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 7.8</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. </span></p>\n<p style="padding-left: 120px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">a. </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">CITATION NOTICE: </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">The citation will be issued based on the evidence that the listing was not entered into the MLS within the 2-business day time frame, nor was an exclusion filed with the MLS. On the Citation Notice, copy all brokers and office managers, then BCC the Association contact. This is a non-correctable violation as the late entry cannot be resolved. Upon the issuance of this citation, the effective list date on the MLS must be updated to reflect the listing agreement provided. </span></p>\n<p style="padding-left: 40px;"><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">d. If the agent and the broker fail to provide a copy of the complete listing agreement by the requested deadline on any inquiry outlined above, </span><span style="font-size: 11.000000pt; font-family: \'Ebrima\'; font-weight: bold; color: rgb(100.000000%, 0.000000%, 0.000000%);">issue a Citation for violating Rule 8.2</span><span style="font-size: 11.000000pt; font-family: \'Ebrima\';">. Please reference this section for the issuance of this citation. </span></p>\n</div>\n</div>\n</div>',
				emailTemplate: "<p>Gotta enter yer listings bro.</p>",
				fineType: "fixed",
				createdBy: "",
				createdOn: "2022-11-01T11:06:30.8657997-04:00",
				id: "f1c6f6c9-8b85-4ca4-bd4e-08dabc1aa7ba",
				modifiedBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
				modifiedOn: "2022-11-07T18:59:08.754788+00:00",
			} as any,
			enumerationLookupId: "",
			corrected: true,
			createdOn: "2023-04-25T19:56:20.8645829+00:00",
			id: "7387163b-6d6f-46dd-e5e0-08db45c72407",
		},
	],
	call: {
		url: "https://thepaciellogroup.github.io/AT-browser-tests/audio/jeffbob.mp3",
		analyst: "Jane Smith",
		agent: "George Jefferson",
	},
	createdByName: "Robert Maher",
	name: "",
	displayName: "",
	templateName: "",
	expiresOn: "0001-01-01T00:00:00+00:00",
	policyReference: "",
	fineAmount: "20",
	actionClassName: "",
	noticeType: "NoticeType.Call",
	status: "",
	activeOn: "0001-01-01T00:00:00+00:00",
	reportViolationId: "00000000-0000-0000-0000-000000000000",
	correctiveActionDeadline: "2023-04-29T17:57:06.053+00:00",
	complianceCaseId: "ed60c444-28ca-4be3-b28c-08db3f743250",
	complianceCase: {} as any,
	reviewDeadline: "",
	suspensionDate: "",
	combineWith: "00000000-0000-0000-0000-000000000000",
	ccEmails: "",
	ccAor: "",
	ccOfice: "",
	description: "",
	statement: "<p>This is a test</p>",
	correctiveAction: "This is a test",
	analystNote: "This is a test",
	corrected: true,
	issuedFailureToCorrect: true,
	createdBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	createdOn: "2023-04-26T17:57:18.0609634+00:00",
	id: "mock-data-id-83838292929",
	modifiedBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
	modifiedOn: "2023-04-26T17:57:18.0609634+00:00",
} as any;

export const mockSessionStorage = {
	timestamp: 1683137613,
	data: {
		isSuccessful: true,
		results: [
			{
				webhookEventStats: [
					...[27, 28, 29, 30, 1, 2, 3, 4].map((item, idx) => {
						return {
							event: "new", ////////////////
							count: Math.floor(Math.random() * (20 - 1 + 1)) + 1,
							day: parseInt(dayjs().format("DD")) - 7 + idx,
							week: 18,
							month: dayjs().format("MM"),
							year: 2023,
						};
					}),
					...[27, 28, 29, 30, 1, 2, 3, 4].map((item, idx) => {
						return {
							event: "unassigned", ////////////////
							count: Math.floor(Math.random() * (20 - 1 + 1)) + 1,
							day: parseInt(dayjs().format("DD")) - 7 + idx,
							week: 18,
							month: dayjs().format("MM"),
							year: 2023,
						};
					}),
					...[27, 28, 29, 30, 1, 2, 3, 4].map((item, idx) => {
						return {
							event: "assigned", ////////////////
							count: Math.floor(Math.random() * (20 - 1 + 1)) + 1,
							day: parseInt(dayjs().format("DD")) - 7 + idx,
							week: 18,
							month: dayjs().format("MM"),
							year: 2023,
						};
					}),
					...[27, 28, 29, 30, 1, 2, 3, 4].map((item, idx) => {
						return {
							event: "closed", ////////////////
							count: Math.floor(Math.random() * (20 - 1 + 1)) + 1,
							day: parseInt(dayjs().format("DD")) - 7 + idx,
							week: 18,
							month: dayjs().format("MM"),
							year: 2023,
						};
					}),
				],
			},
		],
	},
};

export const mockViolations = [
	{
		complianceCaseId: "0b4c3be2-b4fd-4df2-e8f3-08db4a52d47a",
		mlsRuleId: "e6ae4b8a-e20f-491b-bd4d-08dabc1aa7ba",
		mlsRule: {
			ruleNumber: "12.5",
			ruleTitle: "Misuse of Public Remarks",
			warning: false,
			citationFee: 250,
			mlsRulebookText:
				"Information in the public remarks shall only relate to the marketing, description and condition of the property. No contact information is permitted, including names, phone or fax numbers, email addresses or website addresses (including virtual tours and transaction tracking URLs). No showing instructions are permitted, including references to lockbox, alarm, gate or other security codes, or the occupancy of the property (a statement that the property shall be delivered vacant is not a violation of this section). No information directed toward real estate agents or Brokers, including compensation or bonuses offered to Buyer Brokers may be shown in public remarks. No information other than the marketing, description and condition of the property is permitted. By submitting remarks to the MLS, Participant and/or Subscriber represents and warrants he or she has the authority to grant, and hereby grants the MLS and the other Participants and Subscribers the right to reproduce and display the remarks in accordance with these rules. Copying of remarks by a subsequent listing agent for use in his or her own listing requires prior written authorization from the originating listing agent or other appropriate party with the legal right to reproduce and display such remarks. ",
			processingGuideline:
				"Policy: To investigate and aggressively enforce violations of this rule to prevent unnecessary commentary or information from being shared with the public.\r\n                                                Application:\r\n                                                1. Common reports reference the inclusion of the listing agent’s contact information, brokerage information or showing instructions in the property description.\r\n                                                Comments:\r\n                                                1. The following CANNOT be included in the property description or other public remarks:\r\n                                                a. Gate codes, showing instructions, compensation information, lockbox information, occupancy status of the property (Ex: Long-term tenants), email addresses, website addresses, phone numbers, agent or brokerage information, open house information (Ex: Do not disturb tenants, drive-by only), any language that violates applicable fair housing laws and guidelines.\r\n                                                2. Prohibited information, listed above, found in the driving directions or photograph captions WILL be subject to a citation under this rule.\r\n                                                3. The property description may include verbiage that states the property will be delivered vacant.\r\n                                                4. References to “Seller Financing” are permissible.\r\n                                                5. Phrases such as, “Don't wait! Make an appointment to see this one today!” or “Easy to show!” will not be found in violation as they are not intended to advertise the agent or brokerage listing the property.\r\n                                                    54\r\n                                                a. Remarks like, “Agents. Please see private remarks.” will also not be found in violation.\r\n                                                Procedures: Review the listing to confirm the reported violation still exists.\r\n                                                1. If the remarks were removed prior to your review and confirmation is made by reviewing the\r\n                                                audit log, close the case as Corrected.\r\n                                                2. If the listing is still in violation of Rule 12.5, remove the remarks from the listing and issue a\r\n                                                Citation.\r\n                                                a. CITATION NOTICE: This notice will reference the rule and our findings which resulted in the issuance of the citation. The verbiage found in violation MUST be copied directly from the listing and be referenced in the Citation Notice within quotations. The location of this verbiage must also be included (Ex: Driving Directions, Property Description, or the photograph captions). Including the prohibited remarks verbatim strengthens our case and helps support the issuance of the citation. Advise the agent that the prohibited verbiage was removed from the listing by CRMLS Staff. All brokers and office managers will be included on this notice and the Association contact will be included as a BCC.\r\n                                                3. If the listing includes verbiage that is inappropriate (such as safety concerns) but does not cause a violation of this rule, remove the verbiage and send an email.\r\n                                                a. The email will reference our findings which resulted in the issuance of the notice. The inappropriate verbiage MUST be copied directly from the listing and referenced in the email within quotations. The location of this verbiage must also be included (Ex: Driving Directions, Property Description, or the photograph captions). Including the remarks verbatim strengthens our case and helps support our decision to remove the verbiage from the MLS. Advise the agent that the quoted verbiage was removed from the listing by CRMLS Staff. All brokers and office managers will be included on this inquiry.\r\n                                                b. An example of inappropriate verbiage found within the Showing Instructions field is “5-year-old left home alone. Please make appointment before showing property.” Though this is not a violation of Rule 12.5, such verbiage must be removed immediately. No citation will be issued for remarks outside of a public remarks field. However, communication must be sent addressing the use of the remarks and the modification to the listing by CRMLS Staff.",
			emailTemplate: "N/A",
			fineType: "fixed",
			createdBy: null,
			createdOn: "2022-11-01T11:06:30.5910211-04:00",
			id: "e6ae4b8a-e20f-491b-bd4d-08dabc1aa7ba",
			modifiedBy: null,
			modifiedOn: "2022-11-01T11:06:30.5910211-04:00",
		},
		enumerationLookupId: null,
		enumerationLookup: null,
		corrected: null,
		createdBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
		createdOn: "2023-05-01T20:04:04.9352389+00:00",
		id: "adfbd98a-8805-452b-1608-08db4a52d484",
		modifiedBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
		modifiedOn: "2023-05-01T20:04:04.9352389+00:00",
	},
	{
		complianceCaseId: "0b4c3be2-b4fd-4df2-e8f3-08db4a52d47a",
		mlsRuleId: "b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
		mlsRule: {
			ruleNumber: "10.2",
			ruleTitle: "Failure to Timely Report Listing Status Changes and Sales",
			warning: false,
			citationFee: 50,
			mlsRulebookText:
				"<p>a) Listings with accepted offers shall be reported to the MLS or input into the MLS database as &ldquo;pending&rdquo; or &ldquo;active under contract&rdquo; within 2 business days of the acceptance by the Listing Broker unless the negotiations were carried on under Section 9.1 (a) or (b), in which case, the Buyer Broker shall notify the Listing Broker of the &ldquo;pending&rdquo; or &ldquo;active under contract&rdquo; status within 2 business days after acceptance, whereby the Listing Broker shall then report or input the status change to the MLS within 2 business days of receiving notice from the Buyer Broker.</p>\n<p>b) The listing shall be published on the MLS as &ldquo;pending&rdquo; or &ldquo;active under contract&rdquo; with no price or terms prior to the final closing.</p>\n<p>c) Upon final closing, the Listing Broker shall report or input the listing in the MLS as &ldquo;sold&rdquo; and report the selling price within 2 business days of the final closing date unless the negotiations were carried on under Section 9.1 (a) or (b), in which case, the Buyer Broker shall notify the Listing Broker of the &ldquo;sold&rdquo; status and selling price within 2 business days after the final closing date, whereby the Listing Broker shall then report or input the status change and selling price to the MLS within 2 business days of receiving notice from the Buyer Broker.</p>\n<p>d) Listings which were not input into the MLS as a result of the seller&rsquo;s(s&rsquo;) instructions may be input into the MLS &ldquo;sold&rdquo; data at the Listing Broker's option. However, listings which were input into the MLS but subsequently withdrawn must still be reported under this section if the seller is represented by the Listing Broker when it closes.</p>\n<p>e) The MLS may accept the reporting of sales information for comparable purposes about other properties which were not otherwise eligible for input into the MLS but are located in the MLS&rsquo;s service area and &ldquo;sold&rdquo; by an MLS participant and/or subscriber who represented a party in the transaction (i.e. broker who represented the seller or broker who represented the buyer), as long as such reporting is authorized by a party in the transaction to the broker who represented it, (if requested by the MLS documentation must be presented to MLS within 2 business days), and the circumstances of the representation are disclosed on the Service by the reporting participant or subscriber. Any submission of sales information must occur within 2 business days after close of escrow.</p>",
			processingGuideline:
				"<p>Policy: To maintain the quality of data by investigating reports of late reporting of sales and late reporting of acceptance of offers.</p>\n<p>Application:</p>\n<ol>\n<li>This violation typically occurs when a listing is not changed to Pending or Active Under Contract upon the seller(s)&rsquo;s acceptance of an offer, resulting in the status change from Active to Sold on the same day. In those cases, the agent violated this rule because the acceptance of the offer was never reported on the MLS. 37</li>\n<li>Another common report involves a listing that is displaying a status of Pending or Active Under Contract but should be in the status of Closed. In this instance, the agent failed to update the listing upon the property closing escrow.</li>\n</ol>\n<p>Comments:</p>\n<ol>\n<li>Listings that display a status of Auto Sold (noted with a red flag) are NOT to be processed under this rule. Reference Rule 8.3 &ndash; Auto Sold for instructions on how to process under the associated violation.</li>\n<li>Pending should be used when an offer is accepted, and the seller(s) is not accepting back- up offers. If back-up offers are being accepted, Active Under Contract is the proper status. However, it is up to the broker to decide which status is to be used. Compliance does not make that decision for the listing agent or broker.</li>\n</ol>\n<p>Procedures:</p>\n<ol>\n<li>Upon review of the report, verify the current status of the listing.</li>\n<li>If the listing is still in a status other than Pending, Active under Contract, or Closed, send an inquiry.\n<ol>\n<li>Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent either confirm that the current status is correct, or, make the necessary updates. Provide the agent a corrective action deadline of 2 business days and copy all brokers and office managers.</li>\n<li>If corrective action is not taken within the 2 business days, request additional information from the reporting party as a separate inquiry. If additional information is not provided, close the case as Unable to Verify and make a note that a violation was not determined at this time due to insufficient evidence If additional information is provided, such as a copy of an email thread or text message between the reporting party and the listing agent, and the listing is found to be in an inaccurate status based on an admission from the listing agent, issue a Citation Notice under Rule 10.2. i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received and request that the listing agent make the necessary changes to the listing within 2 business days. All brokers and office managers will be copied on this notice and the Association contact will be BCC&rsquo;d. ii. If corrective action is not taken within 2 business days after the issuance of a citation, issue another Citation under Rule 14.4. Reference this section for instructions how to proceed.</li>\n</ol>\n</li>\n<li>If the listing status was updated prior to your review of the report and is Pending, send an inquiry and request a copy of the signed purchase agreement. a. Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent 38 provide CRMLS with a copy of the signed purchase agreement for the accepted offer. Provide the agent with a corrective action deadline of 2 business days. All brokers and office managers will be copied on this notice. b. Review of Documentation: Upon receipt of the signed purchase agreement, verify that the purchase contract date on the MLS is consistent with the date of the accepted offer. c. If the dates are consistent but the change in status was made after the 2-business day time frame, as outlined in Rule 10.2, issue a Citation. i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received. All brokers and office managers will be copied on this notice and the Association contact will be BCC&rsquo;d. This violation CANNOT be corrected. d. If the date on the MLS is inconsistent with the documentation provided, follow-up with the agent via email and request if any other documentation, such as signed counter offers, can be provided which would support the date on the MLS. e. If additional documentation cannot be provided, issue a Citation under Rule 10.2, as outlined above. Upon the issuance of the citation, modify the purchase contract date to reflect the signed purchase agreement. f. If additional documentation is provided and matches the MLS but the change was made outside of the 2-business day timeframe, issue a Citation under Rule 10.2, as outlined above.</li>\n<li>If the listing status was updated prior to your review of the report and is Closed, send an inquiry and request a copy of the Final Closing Statement. a. Inquiry: This notice will reference the report received and will include information regarding the potential violation of Rule 10.2. Within the notice, request the agent provide CRMLS with a copy of the Final Closing Statement. Provide the agent with a corrective action deadline of 2 business days. All brokers and office managers will be copied on this notice. b. Review of Documentation: Upon receipt of the Final Closing Statement, verify that the Reported Date on the document is consistent with the close of escrow date on the MLS. c. If the dates are consistent but the change in status was made after the 2-business day time frame, as outlined in Rule 10.2, issue a Citation Notice. i. CITATION NOTICE: This notice will reference the report received and will include information regarding the violation of Rule 10.2. Within the notice, reference the evidence received. All brokers and office managers will be copied on this notice and the Association contact will be BCC&rsquo;d. This violation CANNOT be corrected. 39 d. If the date on the MLS is inconsistent with the documentation provided, modify the close of escrow date to reflect the closing statement and issue a Citation under Rule 10.2, as outlined above, if the status change occurred more than 2 business days from the close of escrow date.</li>\n</ol>",
			emailTemplate: "<p>Please correct the Listing to update the Status and Sale Date.</p>",
			fineType: "percentage",
			createdBy: null,
			createdOn: "2022-11-01T11:06:30.1631807-04:00",
			id: "b2848b36-6df6-454b-bd4c-08dabc1aa7ba",
			modifiedBy: "5c1f9d04-2404-44ac-9e9d-148eff99b89c",
			modifiedOn: "2023-03-17T19:29:39.8175501+00:00",
		},
		enumerationLookupId: null,
		enumerationLookup: null,
		corrected: null,
		createdBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
		createdOn: "2023-05-04T15:24:20.2423198+00:00",
		id: "483daa36-eab9-4f08-9f91-08db4cb3a1e9",
		modifiedBy: "a181ec35-cfd1-409e-b2cc-af0f7c32621a",
		modifiedOn: "2023-05-04T15:24:20.2423198+00:00",
	},
];

export const mockReportReasonCategories = [
	{
		displayText: "Other",
		description: "Other",
		value: "8",
		createdBy: null,
		createdOn: "2023-06-06T11:28:59.6692874-04:00",
		id: 8,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:59.6692874-04:00",
	},
	{
		displayText: "Fair Housing Law/Guidance Violation",
		description: "Fair Housing Law/Guidance Violation",
		value: "7",
		createdBy: null,
		createdOn: "2023-06-06T11:28:59.3764386-04:00",
		id: 7,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:59.3764386-04:00",
	},
	{
		displayText: "Misleading Information",
		description: "Misleading Information",
		value: "6",
		createdBy: null,
		createdOn: "2023-06-06T11:28:59.090609-04:00",
		id: 6,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:59.090609-04:00",
	},
	{
		displayText: "Inaccurate Information",
		description: "Inaccurate Information",
		value: "5",
		createdBy: null,
		createdOn: "2023-06-06T11:28:58.7934417-04:00",
		id: 5,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:58.7934417-04:00",
	},
	{
		displayText: "Status",
		description: "Status",
		value: "4",
		createdBy: null,
		createdOn: "2023-06-06T11:28:58.5047553-04:00",
		id: 4,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:58.5047553-04:00",
	},
	{
		displayText: "Compensation",
		description: "Compensation",
		value: "3",
		createdBy: null,
		createdOn: "2023-06-06T11:28:58.2205239-04:00",
		id: 3,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:58.2205239-04:00",
	},
	{
		displayText: "Public/Private Remarks",
		description: "Public/Private Remarks",
		value: "2",
		createdBy: null,
		createdOn: "2023-06-06T11:28:57.9341423-04:00",
		id: 2,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:57.9341423-04:00",
	},
	{
		displayText: "Photographs/Media",
		description: "Photographs/Media",
		value: "1",
		createdBy: null,
		createdOn: "2023-06-06T11:28:57.509455-04:00",
		id: 1,
		modifiedBy: null,
		modifiedOn: "2023-06-06T11:28:57.509455-04:00",
	},
];

export interface SalesForceCase {
	id: string;
	isDeleted: boolean;
	masterRecordId: string;
	caseNumber: string;
	contactId: string;
	accountId: string;
	assetId: string;
	sourceId: string;
	businessHoursId: string;
	parentId: string;
	suppliedName: string;
	suppliedEmail: string;
	suppliedPhone: string;
	suppliedCompany: string;
	type: string;
	recordTypeId: string;
	status: string;
	reason: string;
	origin: string;
	language: string;
	subject: string;
	priority: string;
	description: string;
	isClosed: boolean;
	closedDate: string;
	isEscalated: boolean;
	ownerId: string;
	isClosedOnCreate: boolean;
	createdDate: string;
	createdById: string;
	lastModifiedDate: string;
	lastModifiedById: string;
	systemModstamp: string;
	contactPhone: string;
	contactMobile: string;
	contactEmail: string;
	contactFax: string;
	comments: string;
	escalation_Status__c: string;
	escalation_Owner__c: string;
	site__c: string;
	template__c: string;
	level__c: string;
	group__c: string;
	related_Compliance_Chat__c: string;
	scope_of_Impact__c: string;
	category__c: string;
	subcategory__c: string;
	item__c: string;
	service_Category__c: string;
	dev_Request_Type__c: string;
	type_of_Request__c: string;
	product__c: string;
	your_MLS__c: string;
	course_Topic__c: string;
	office_ID__c: string;
	memberLoginId__c: string;
	dianes_Test__c: string;
	screen_Shots__c: string;
	resolved_Date__c: string;
	escalation_End_Time__c: string;
	survey_Email_Destination__c: string;
	cgcrmlsfeedback__Comments__c: string;
	cgcrmlsfeedback__Question_1__c: string;
	cgcrmlsfeedback__Question_2__c: string;
	cgcrmlsfeedback__Question_3__c: string;
	cgcrmlsfeedback__Question_4__c: string;
	cgcrmlsfeedback__Question_5__c: string;
	cgcrmlsfeedback__Question_6__c: string;
	no_Survey__c: boolean;
	legacy_Case_Number__c: string;
	resolution_Summary__c: string;
	memberMLSSecurityClass__c: string;
	escalation_Owner_Lookup__c: string;
	update_Linked_Case__c: boolean;
	check_Escalated__c: boolean;
	ccD_Survey_Question2__c: string;
	ccD_Survey_Question3__c: string;
	san_Diego_User__c: string;
	ccD_Survey_Question1__c: string;
	ccD_Survey_Question4__c: string;
	ccD_Survey_Question5__c: string;
	ccD_Survey_Question6__c: string;
	ccD_Survery_Comments__c: string;
	special_Project__c: string;
	special_Project_Type__c: string;
	special_Project_Subtype__c: string;
	compliance_Description__c: string;
	sP_Time_Duration__c: string;
	compliance_Agent_Chat__c: string;
	business_Use__c: string;
	level_of_Effort__c: string;
	compliance_Citation_Review_Status__c: string;
	compliance_Escalation_Email__c: string;
	compliance_Reporting_Agent__c: string;
	compliance_Disposition__c: string;
	compliance_Disposition_Notes__c: string;
	compliance_Fine_Amount__c: string;
	compliance_Fine_Paid_1__c: number;
	compliance_Fine_Paid_2__c: number;
	compliance_Case_Number__c: string;
	compliance_Invoice_Link__c: string;
	compliance_Invoice_Status__c: string;
	compliance_Invoice_Voided__c: boolean;
	compliance_Listing_ID__c: string;
	inquiry_Statement__c: string;
	compliance_Payment_Type_1__c: string;
	compliance_Payment_Type_2__c: string;
	compliance_Related_Compliance_Case__c: string;
	compliance_Reported_Date__c: string;
	compliance_Case_ID__c: string;
	compliance_Suspension_Status__c: string;
	compliance_Warning_Required__c: string;
	compliance_Warning_Notes__c: string;
	compliance_Violation_Corrected__c: string;
	compliance_MLS_Rule__c: string;
	link_to_Requested_Item__c: string;
	reportable_Event__c: string;
	compliance_iCheck_Ticket_Number__c: string;
	compliance_Roster_Agent_name__c: string;
	citation_Statement__c: string;
	compliance_Paragon_User__c: boolean;
	compliance_Listing_Status__c: string;
	inquiry_Corrective_action_needed__c: string;
	contact_reported_by_Email__c: string;
	contact_reported_by_ID__c: string;
	contact_reported_by_Name_del__c: string;
	transaction_ID1__c: string;
	listStatus__c: string;
	manual_Confirmacion_Email_Sent__c: boolean;
	transaction_ID2__c: string;
	send_flex_email__c: boolean;
	citation_Corrective_Action_Needed__c: string;
	warning_Corrective_Action_Needed__c: string;
	listing_Office_Name__c: string;
	id_Compliance_Cases__c: string;
	marketing_Reassigned__c: boolean;
	broker_MLS_ID__c: string;
	property_Address__c: string;
	office_City__c: string;
	agent_Marketing_Property__c: string;
	title__c: string;
	broker_Name__c: string;
	office_Name_broker_request__c: string;
	topic__c: string;
	preferred_Time__c: string;
	do_not_share_to_portal__c: boolean;
	type_of_Marketing__c: string;
	cType_Of_Marketing__c: string;
	broker__c: boolean;
	office_Broker__c: string;
	linked_Broker_Office_Visit__c: string;
	platform__c: string;
	training_Link__c: string;
	virtualinperson__c: string;
	other__c: string;
	speaker__c: string;
	moderator__c: string;
	speak_Time__c: string;
	anticipated_Number_of_Attendees__c: string;
	speaker_2__c: string;
	combined_Violation_Y_N__c: boolean;
	refund_Transaction_ID__c: string;
	refund_Type__c: string;
	case_Refunded__c: string;
	preferred_Speaker_text__c: string;
	x10_CRMLS_Hosting_Event__c: string;
	agf__ADM_Work__c: string;
	member_Experience_Feedback__c: boolean;
	salesforce_Platform__c: string;
	for_Review__c: boolean;
	reviewed__c: boolean;
	individual_to_Review__c: string;
	secondary_Individual_to_Review__c: string;
	user__c: string;
	trainer__c: string;
	review_Notes__c: string;
	dC_Packet_Created_By__c: string;
	dC_Packet_Status__c: string;
	dC_Violation_Corrected__c: string;
	broker_Engagement_Coordinator__c: boolean;
	written_Review__c: boolean;
	full_Hearing__c: boolean;
	related_to_7_9__c: string;
	on_Hold_Scheduled_Notes__c: string;
	quality_Assurance__c: boolean;
	missing_Items__c: string;
	original_number__c: string;
	owner_Name: string;
	createdBy_Name: string;
	member_Login_Id: string;
	member_Name: string;
	member_License_Number: string;
	notes: HistoricalNote[];
}

export interface HistoricalNote {
	caseId: string;
	noteVersionId: string;
	title: string;
	textPreview: string;
	created_By_Email: string;
	created_By_Name: string;
	createdDate: string;
}
export const tempCorrectionStatuses = [
	{ id: "1", name: "Missing Info", description: "Listing is missing critical information", icon: "fa-exclamation-circle", tooltip: "This listing is missing critical information. Please review.", color: "#FF0000" },
	{ id: "2", name: "Verified", description: "Listing has been verified", icon: "fa-check-circle", tooltip: "This listing has been verified and is accurate.", color: "#008000" },
	{ id: "3", name: "Duplicate", description: "Duplicate listing found", icon: "fa-clone", tooltip: "A duplicate of this listing has been detected. Please check.", color: "#D2691E" },
	{ id: "4", name: "Price Error", description: "Price seems incorrect", icon: "fa-dollar-sign", tooltip: "The price of this listing seems incorrect. Verify pricing.", color: "#FF3333" },
	{ id: "5", name: "Incomplete Photos", description: "Photos are incomplete or missing", icon: "fa-camera", tooltip: "This listing has incomplete or missing photos. Add more photos.", color: "#DAA520" },
	{ id: "6", name: "Compliance Issue", description: "Potential compliance issue detected", icon: "fa-balance-scale", tooltip: "A potential compliance issue has been detected. Review required.", color: "#8000FF" },
	{ id: "7", name: "Good Condition", description: "Listing is in good condition", icon: "fa-thumbs-up", tooltip: "This listing is in good condition and ready for review.", color: "#0000FF" },
	{ id: "8", name: "Pending Review", description: "Listing is pending review", icon: "fa-hourglass-half", tooltip: "This listing is pending review. Please check soon.", color: "#A9A9A9" },
	{ id: "9", name: "High Priority", description: "Listing requires immediate attention", icon: "fa-exclamation-triangle", tooltip: "This listing requires immediate attention. Address it promptly.", color: "#FF0000" },
	{ id: "10", name: "Approved", description: "Listing has been approved", icon: "fa-thumbs-up", tooltip: "This listing has been approved and is ready to go live.", color: "#006400" },
	{ id: "11", name: "Expired", description: "Listing has expired", icon: "fa-calendar-times", tooltip: "This listing has expired. Consider renewing or removing it.", color: "#A9A9A9" },
	{ id: "12", name: "Fraudulent", description: "Listing flagged as potentially fraudulent", icon: "fa-ban", tooltip: "This listing has been flagged as potentially fraudulent. Investigate immediately.", color: "#FF0000" },
	{ id: "13", name: "Updated", description: "Listing has been recently updated", icon: "fa-sync", tooltip: "This listing has been recently updated. Review the changes.", color: "#87CEEB" },
	{ id: "14", name: "Low Quality", description: "Listing has low-quality content", icon: "fa-thumbs-down", tooltip: "This listing has low-quality content. Consider improving it.", color: "#CD853F" },
	{ id: "15", name: "Overpriced", description: "Listing is overpriced", icon: "fa-tag", tooltip: "This listing appears to be overpriced. Verify the pricing.", color: "#FF0000" },
	{ id: "16", name: "Under Review", description: "Listing is currently under review", icon: "fa-search", tooltip: "This listing is currently under review. Check its status.", color: "#6A5ACD" },
	{ id: "17", name: "Sold", description: "Listing has been sold", icon: "fa-handshake", tooltip: "This listing has been sold. Update its status accordingly.", color: "#008000" },
	{ id: "18", name: "Needs Attention", description: "Listing needs further attention", icon: "fa-exclamation", tooltip: "This listing needs further attention. Address the issues.", color: "#FF0000" },
	{ id: "19", name: "Good Photos", description: "Listing has high-quality photos", icon: "fa-camera-retro", tooltip: "This listing has high-quality photos. No action needed.", color: "#66CDAA" },
	{ id: "20", name: "Location Issue", description: "Listing has incorrect or missing location details", icon: "fa-map-marker-alt", tooltip: "This listing has incorrect or missing location details. Verify the location.", color: "#FF0000" },
];
